var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRoomDetails = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9 {\n        fill: none;\n        stroke: none;\n      }\n\n      .cls-10 {\n        font-family: MyriadPro-Regular, 'Myriad Pro';\n        font-size: 12px;\n      }\n\n      .cls-2, .cls-3, .cls-4, .cls-5, .cls-8, .cls-9 {\n        stroke-linecap: round;\n      }\n\n      .cls-2, .cls-4, .cls-5, .cls-6, .cls-8, .cls-9 {\n        stroke-width: 35px;\n      }\n\n      .cls-2, .cls-4, .cls-6, .cls-7, .cls-8, .cls-9 {\n        stroke: #00abe9;\n      }\n\n      .cls-2, .cls-6, .cls-7, .cls-8, .cls-9 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-11 {\n        fill: #8cc63f;\n      }\n\n      .cls-3 {\n        stroke: #b2b2b2;\n        stroke-width: 5px;\n      }\n\n      .cls-3, .cls-4, .cls-5 {\n        stroke-linejoin: round;\n      }\n\n      .cls-12 {\n        clip-path: url(#clippath-11);\n      }\n\n      .cls-13 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-14 {\n        clip-path: url(#clippath-3);\n      }\n\n      .cls-15 {\n        clip-path: url(#clippath-4);\n      }\n\n      .cls-16 {\n        clip-path: url(#clippath-7);\n      }\n\n      .cls-17 {\n        clip-path: url(#clippath-9);\n      }\n\n      .cls-18 {\n        clip-path: url(#clippath-8);\n      }\n\n      .cls-19 {\n        clip-path: url(#clippath-5);\n      }\n\n      .cls-20 {\n        fill: #3fa9f5;\n      }\n\n      .cls-5 {\n        stroke: #b2b2b2;\n      }\n\n      .cls-21 {\n        fill: #5f6368;\n      }\n\n      .cls-7 {\n        stroke-width: 14px;\n      }\n\n      .cls-22 {\n        fill: #00abe9;\n      }\n\n      .cls-23 {\n        fill: #00abe9;\n      }\n\n      .cls-8 {\n        stroke-dasharray: 14.02 46.72;\n      }\n\n      .cls-24 {\n        fill: #f8bb3d;\n      }\n\n      .cls-25 {\n        fill: #009fe3;\n      }\n\n      .cls-26 {\n        fill: #bdccd4;\n      }\n\n      .cls-27 {\n        display: none;\n      }\n\n      .cls-28 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-9 {\n        stroke-dasharray: 0 60;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1688.85,457.97l-43.12,21.76-371.06,181.4v150.91l350.91-285,71.02-57.04c2.86-2.31,3.53-6.41,1.54-9.5-1.36-2.12-3.67-3.3-6.05-3.3-1.09,0-2.2.24-3.24.78"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1732.81,508.57l-48.18,42.96-409.96,364.51v271.24l415.43-596.03,53.3-73.07c2.17-2.98,1.76-7.11-.97-9.58-1.37-1.24-3.11-1.86-4.83-1.86s-3.43.6-4.79,1.82"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1274.67,
    y: 204.06,
    width: 759.42,
    height: 983.22
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1798.97-282.89l-43.12,21.76-371.06,181.4V71.18l350.91-285,71.02-57.04c2.86-2.31,3.53-6.41,1.54-9.5-1.36-2.12-3.67-3.3-6.05-3.3-1.09,0-2.2.24-3.24.78"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1842.93-232.29l-48.18,42.96-409.96,364.51v271.24l415.43-596.03,53.3-73.07c2.17-2.98,1.76-7.11-.97-9.58-1.37-1.24-3.11-1.86-4.83-1.86s-3.43.6-4.79,1.82"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1384.79,
    y: -536.8,
    width: 759.42,
    height: 983.22
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1781.47-985.01l-46.46,23.44-399.78,195.44v162.59l378.07-307.06,76.51-61.45c3.08-2.49,3.81-6.91,1.66-10.24-1.46-2.29-3.95-3.56-6.52-3.56-1.18,0-2.37.26-3.49.84"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1828.83-930.49l-51.91,46.29-441.69,392.72V-199.25l447.59-642.16,57.43-78.72c2.34-3.21,1.89-7.66-1.05-10.32-1.48-1.34-3.35-2.01-5.21-2.01s-3.7.65-5.16,1.96"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-11"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1335.23,
    y: -1258.57,
    width: 818.2,
    height: 1059.32
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_4",
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("g", {
    id: "oMHC52.tif"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Layer_0",
    width: 258,
    height: 261,
    transform: "translate(-12.98 -21) scale(2.07)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQUAAAEICAYAAABWCOFPAAAACXBIWXMAAAVhAAAFYQEB2H3xAAAgAElEQVR4nO2dXY/syJGe30yyqtnTp88MZBuyrIUteSTD8mIW0EIwYMAwYMA/wn9u/4Zv/QkYWAgQ9sIXC3tXH5i11iN7tnVUXywyM31RnX3qsKpIRpAZVZ0dDzAX06eqgplvMJjMzMgwP/vZzwJGEML5j136u6IoMhhjSH/v4+c//7kp+z7QveE1ACjK7XHuvjTGfPJ3SoCws1yVoijZcDJS0NGBorx+uqMEyqjhk5HC8RdDCBoQFCUDuvfy0H1dph4ZaGBRlGlwJgzPEe/F45HDud8uu1/gGFEUJR1j7jNK4OgGh+53T0YKUy9OA4WipOVcAOjed2OCRAwI3cDQuyR5yeClvymKkp5L997xjd33etD9rW5gmHWfgve+998VRZkHa093E5xbYRgTHI4DA3AhKIwJBhoAFOV6nLv/jgNFNxgMBYfekULf0gUlEOjrhaLMy9CrwPH9GQPEueDQFxiATlA4FxB+8YtfkC58t9vBOYemaUjfe3x8RFEUoz/vnMNms4FzjmSnqipUVUX6ztPT08kGkCHKssS7d+9IdlarFQCgbVvS97744gvS57kaAaoTcPs6dTX66U9/+kkw6AsMwNHmJcrmhiGapsFisZj0G2NwzpEcdApDHTkXbduiLEfN/05CSiNAdZrCnDqNvcdt326nKfMGOQYGYL6NJH28RocbQnXiM1Wn4/t4TGC4uM15jonEpmlEOs05h7IskzvC2GWeOZB0OAk7gOo0hak6XQoM5zj7+jDnykLstNQCtW2LoijU4SbYkWqT6jTNDrdN5wLDuQBxsthJiShjkXIESYczxpxdK54bSYeLfac60bmGTmOhPvA/mVPoBoQ5lxVzCwyxr6QcTuJ9PNpRnXhI6zS277r3cuyTS6MF0UNWpANDakeQdDipibq2bVWnCUjqlEqjl15KOUo4RtLhrLXqcExUJz63GBgoo4WzPZR6N6Kkw0m8U8YOlnCEXAOD6sSDGhjGcKKC1PZkKYdzzqnDTUB14vNaA4P13l8tuSk3h4tbeXNyOEB1mmrr1gJDpPsKERlMiNrtduQLpO5ZL8sS+/2e7HRUO8YYeO/JbeLYcc6R7ZRlSVrW4toB6G0CVKfILet0TqOxeQ+DCVHx/6kJGZxEFgDYbDao63r05zmJLABQ1zXquiaNjqiJLAAvEYiabAQcNNpsNiIaAaoTcPs6dTXqBoLRCVGXkNof770X2fwRQhCZ7Y62Ug8djTGiOQyqEw9JnaZqdLHHj0cNUo1p21bMjtQymITDAbLJTaoTn2vdS5QFhN66D8dIJc5IdlqODieV3KQ68bnGvUTJhCb19GtJFR1Ljg4npRGgOk1B8l4aw+DmpT5i+mtqpKJpjg4npRGgOk1BUicKZ1On+4grElKOoE8iOpIaAaoTF2mdurYvwepdycZID1ElsvZydDjVicc1A8Ml2CFXOjDcaq46h1wdTnXicWuBYdI4TPpVQvLdVR2Oh+rE45YCw+SXsxwDg9R+9VwdTnXicSuBYZYZmxwDg9QpOrk6nOrE4xYCw2znKcTGSBDz71MTn0Sps0ijw6W2I6kRoDpxSaXT2Pt6MBw9Pj6SDO/3e2w2G3LHLZdL3N/fj/68cw7r9ZocwMqyJLdptVqhKAraVlFryXa22y2apiH3nZRGgOoE3L5OVI0isdcGgwJ1uGSMQV3XKMuSVFbr/v6ebGuz2ZDtlGVJthOfEAAh2jLsAIcZ/KIoSG2S0ghQnSK3rBNHIwAvUSHZLhDJDS1SWXsSQ+EQguipwJJJVKoTD0mdgMSnOUtuaJFwOO+9SCovIDezLp1dqTrxkNQpec9pYOCTo8OpTnykdBLpNcmdbupwPCTTrlUnPil1itOZYsVgcptj8N6LHZzqnBOrcLRYLFQnJtI6pUK0QlRurxKSJypLPfWaplGdJiCpUyqNRIMCIPsqIeHYOTocoDpNQTIwpNBIPCgA+Z3gJO1wEktugOo0BSmdUmh0laAAqMNNQWotHlCdpiCl09waXS0oAOpwU9HAwCNHnebUaPBXOIkZ1ItbLBZkO9RMshAClsslK9mE2h6uHWstq/KQhEaA6hS5ZZ04Gp3YHPoAtXpOVVWsikDr9RqbzWb057mVh7bbLVarFSlphlN5qG1brNdrUjILp/KQ9x7r9VpEI0B1Am5fJ6pGXQZfH6SGWiEEkSGqMUbkKC9jzIutlFhrxd+TVSc6kjpN1WjUnIJk5dyczvjLsboxoDpNtXXr99LoicZcT1bKzeFy26qsOvHhakRafbj1xnDsSDqcxIYWDQx8ctSJel4GQAwKuZ7FWJaliMMZY5I7XM5nMapOMpBbnmNgiNtF1eF4qE48bjUw3HyFKHU4HhoYppGrTmOYVCHKe59V0kyODielEaA6cZHWaYhJrfXei+WrS22BjQdypkbK4SQ1AlQnLtI69TG5pZKlu3PM88+pinJEdeIhrdMlZmllroFBy6vzUZ143EJgmK2FsTESGWFN04iebsOpmEUhOlxqO5IaAaoTF2mdugyOvaqqIv2g9x51XbMqAlGz6bbbLavjqG3abrfkykMcO/v9Hs655Ha4GgGqE3D7OlE1Ovn+0AeoDdntdqjrGtZa0m4qauaZc+6lTBjFTlVV5DY9PT2hKApShhsnO3C1Wr04GyVrj5odyNUIUJ2A29eJk8V5TJKxXZxJTT0JJLnGK5XIIj3bLVW1SXXiIalTJFmLNDBMs5Obw6lOfKQDQ9LW5BoYpOwA6ZNzcg4MqhOP5FPD0oEhp/Xx+L6ak8OpTtPsSOgkcnCrZGDIsRIVIOtwqhOdnAKD2OxF7LSyLAdnUj0AB6AFEJ7//2VV5nllywFYm/MCGOdhl0u45tROC4OGeO2X7MB5FIsFXHs6210YA+qC39oYuHO2wvOJwEWB4E9/lfr2XMOgvmTnuaPthXZR7b1FnUxRwPsAA8AgwOLQZx7zPIUp9xIH0QyMuCmjrzEOwArAL33A1wC+CcAHADsEfCJpMPCfPfTaM4u7E8GNOTgj6bqH7Cxxagd0O2FZISxJXwEAWKqdskQohqU/1y4bDECx9wZ1MgBsAO4M8Og9/p53+J73+GMA70AP4ucYcy9xEU/Liu+U3fXkFsBvA/C/QsAvA/ABAWsANYAmHILFSUTn7viiPhpyswPzMuISsZdb/42wY8xhVPD7wuIba/HrEPCXLuCHBviRMfiemR4cLt1LU7lKruZxqmjbttgag18B+Gsf8CsEfBM+lsVWlNdIwOFB5mCwM8AHY/BNCPg7AN8G4EcW+NIYfIaJ8blzL83B1RK4QwjYty3qssRfGYv/AYOvEVCn3VauKFfDA/jbAPydCfidN2hNwI+swQOmjRrixO1cI4arnuqwMRa/Nhb/eXmHP+joQHkj1AH4JQK+DYCBwZcWeMS0EQMw36atwaDw9PRE+sGqqkbt8d4A+L8B+C/OYwUNCMrbwgP4PYD/0Dr826bGP20bVJ3Ep7H30ie/6z1WqxUpJ6PL4ApJivRNj8P8wc+9x+8BzDdFoiivBw/gD9bgL4oFfl2U9PniM1hrJx+HPxgUYl73nMHh/wTgfwbgN/rKoLxxPID/XVj8qijxu5nyNWKqNXcj1ahvRSNzBAaHw7LjrxGwm/xrivL6qY3B10WBXxXFbA/JuCrBCQyjvzFHYPA4zCX8dTiMFhRFOfA7a/EbW2I78zZpztwCuUIUwB+WOBzmEn7f3Z2oKG8cD+CDtfhNUaC90jFsEVaFKIAXGByAr593KiqK8ilbY/BbW1z9gcl65HMzwjwOuQw6l6Aop9QA/p+1V598Z7/AcAKDxyG5qdH5BEU5oTEGH6ydZWlyCpN2NMbZTWvtqAmNEIAtePsSDICHEF52fRkAxtLfvUIICAO9bvBpjox9tlNPGOXchYBuYt2JHcNLVPJn0qkjexxmt7lUOGT7RYIPg0573C6uTrtweHJy6F5zLwHwAw5B1SkEsDbkeRzS2sOJRVkmb3OOpa7G7rs+m+04gocQ8O+3GzxaA+88irLAw0N/quw56l2Nuh52t6IsXvLv33/+HgDw31zAf2Se+f+nTYN/2ezP2vHukAb78O6BtU31w+rDxX/788US/33JyMd+5l8Zg39dfLwD1rv1xXMWjrGFnaTTf9q3+K/MCe3uNffhnMN6PTzLRdFpFYA/cx6XVTlPPDvEFhZor/cSMUvuQ9xzPejQEyZV40jhvj3YMiGAdjD3gQUCyjCiw5uPmWePz39aTgjgSwQ8nLP7bMc5z861dz3tWU584iwNXtoPHA5hacf0X+sn6XR6wsJ4utfchwMAgj+M0sk8Z1czmhC/kkWFqDhKkKhqE2v7pSYe5SVReeja9QNTIKWTFFI6+edDX262QhT1LDjn3MXXiENU5jXU4DCEK8PByWK6KKfjqG3a7/eH4PByJXSssYN2m6ZhlQvr+1176YiykYTgcSyntcPt+PT7fJ24dK+5D86pz0M6zeHn5vkAFU4qNFWjLoPfpFbP2e122Gw2Z6vnrI09HJnFcBBjDR4eHl6GovFd0BhD6riqqshtipWH6qIElnek70aWd0u8s/3fXa1WaNuWXJKsL5Nu6QPQMxE5RF3v8Yf9xzkYToUojk4YOFqtj+4198GtENWn01x+3ncv9XGTFaIki2QAMu9fzrnJT90xxCHqtYaOKZDUCZg+OhqDlE5S99IxySxJNSY+fUTe9cZMSM1AjoFBWicJO7kGhqRWcgwMUmhgmEZcKk9NjoEhuQXJwBBC0MBw40jpdHygaWpyCwwi45HYGM7ONgrxLHwNDLeNlE6StStzCgxisxcvgSGxHQ0MrwMNDHxSBwbRnSWeWImHbUcDw6sg18Bgi/S3VcrAIL7dTCrNI9fAYK0VDQypbeUYGFzrko+IgXSBIZ89qGc4rreXC9Jbhw1k9ptI6CQZGKQefikCQ9ZBAZAp3S3NXEU/xuCDF9uIJqGTZGCQYu7AkH1QADQwzGFLA8NtM6dGg72yWq1oP1iWeHy8nLhqmYkiwQesd2uYozMi++yc/Y0QsN/vyW2Kdu4A9rhwX++xck3vZ5bLJe7v70m/27Ztb3v2xQJYLEi/eczd3RKPd4fzGLz32G63pO9zdQqOPwA/vuYhmqYh+8MYnebw86F76RwcjbqMCpWUarZlWV58ghUA4Dw7z9y17iWXv89OHzHzjJKcE+0YHzB4bNMFfPCD/Xh/f09uk7UWTdNc/G1vp40mjLEonveXFEWBpmlesgTHwNXJBH4F5eNrHiJmcVJ8fEinufyc03ccjboMjjXimQK5cDiOLZ9VCWOMqEZS24e5wZdKzN7MycenajTqBSS3wJDrcqWURrkdCpPjHMMUjUbPSuQaGMQyz4TSeaU0kpzolCDHwMDViOSpOQYGgF/xikIIcsk5Ghh45BoYqJDvBg0MPAJ4R39x0MDAJ8fAQIV1J+T2ThkDQ+otvddIzpEgtwNa33pgYCuZ2xPC+8POvZwCg9QRcsDHwkC58JYDwyQVJQODRIKJ9IghpyPkgHwDQ04PvzFMVlCq0wJkzsGPGz4kAoPYmr8gccSVC9I63ULPzRLWxQLD81n7EjcsIDD5mOmTSEonKSR1CoDIeQx9zFohSuIQEOknucRwONfAAFyvylEKxF75nL/qgTqzenzMKUhdZi1GbkqBDC7ee9ZaLxXnHNq2Td53kkjqJIWUTlL30jkGp1b7qg+dI1a1aZrTjMAplXOsNXj/+fuXwqGx8hD1hq2qitymp6cnGGOwWyzZFaKqqsIXn/Vn1q1Wq97kpkv0taeaWCFqt9vhaYYKUeTAOqFCVPea+yjLkuwPQzrN5ed991IfN1khqmkaLCak645FctgdQhCZBMptcxgg/3qUk05S99IxyV6YcwwMUmhgmI7E+3iugSHpLFrTNGKbdMqyTD/5mPTXPyXXwCCpU26BQcofkk+tx05LLVCOR6DnGBikdJJc/ZDSSepeElkQlXIEDQyvA8nAIFV/UTIwpO47sV0SUkUycg0MOc6bSOgkmR4vpVPqvhPdOiVVJCN2Wk778HOdUJXQSTIwOOde/cMv2wpRsZqSBoZppA7iUjpJBgbvvOjDb+7AkM8dc4a2bcXeKaWQX9pLX6ZOSqcYGKRyGCRIERjyuVsuIFXIRBLpClE5VFKOSAYGKeYODPncKT1oYJhGLiXWj+0AGhguMbiGstvtyD9aVdXZv7cwnO3gAA7LS/WuxuJoYHbJziWMMfDek9sU7SwmFFZxbYud79//X5YlaVkr1izoa4+zBTDhuhdlieq5sEpZltjv92TH4+g0JQ/o+JqH7Az13zmGdJrTz6l9x9Xok98Y+oBzjpSQUVXVxYY0AAy3ck4A6rpGeVQh6t27d+TfqesadV2TMvdiwkwxIbmoaVvsBpJ0OIksIYTepJlmeQcs+UGhKEtU9uMW281mg7oel2wE8HUyDb9CVPea+3DOYbPZkBK2hnSay8/77qU+qBp1GQwKcd81NVPrVjmu9UBN6a0AfD42AIePu+oCgLtEU0/GmF6N7hDw2HnsGjN+p1/XJWMBWGomJ5VlCHiPj/03Bvs8OqDeRrEwkESKvARTNRo1Vs0tMBzvPqMEhp9Zgz8ZudgUU4aNPZxAVCR2uEsa/UnT4Cedp+7d3R3uqnEp4OfKtLZtm9wf/tQ7/LjeoiiLQ+GeESO095+/B3D+mvuIh+nkFBimaDT6BTYmZKR+QkjBCQx3z/+NwQFA8IA7rI0ba5M73DmNliFg2XnWVgjkp+k5WykDwxLAQ/BAc3jqeRMGdaLVZ/6UHAMDN7vyTVeIktw4I1W7UlIjqZTeHHWSghO081mjUxRlFshBIbcCGTk+hSQ1ksrzz1GnW4XcwzlWzsnN4aQ1ipNaEnZy0ulWYfVuzoFBIpU3x8AgPb+Qi063CDvkSjvda84665JzYMjloBHg7QaGSeMwSacLAIpSZvY+pyfRNV4lJOcYctEpcgtHA01+OROtotzKVWsWqQSkgWESuekEyD38+phlxkbS6aTPwkuNBobpdnLSCTgc0nLN+brZpnGj00kQD+VITXwSpS57Fh0utR1JjQDViYu0Tl0Gw9HjI23z6H6/x2azOdtxa2MQlhWvnJYxeHj3cFI2jlprryxLcptWqxWKoiDZstaS7Wy3WzRNQ3a6OTUaYrlc4v6+v/zdMW9Rpzn8/B34OlE16jIYFKjDJWPMIfXzTJ6EMxaBmq3y8sOHazm+ms1mQ87HKMuS3Kb4hAAw2uE4doDDDH5RFKQ2zanREPf392R7b02nufycqxNHo2OS7QKR3NAisvrxXENAwo7kUeFS5chUJz6SOgECZeNyCgwxk04CqZl1yTqFqhMfSZ2S95wGBj45OpzqxEdKJ5Fek9zppg7HQ7KAqerER0In0bJxxSKvwCC1y805J1b2bLFYZDeyy1WnVMiWjWtasRyGnHbUAXJPvaZpsnvlk9bJjDhJeiopNcq6bJyEY+cYGADZV77cdAo+iDz8UmmU9clLUk888SeRUEVtqSd5jjpJPvzm1ijroABk6nBCa/GABobXwNwaZR8UgHwdTgMDDw0M/YyqEEX+0QsXVxjDf9cKh2uJV0PN+AshYLlcspJNqJ3NtWOtZZWNm1OjPhaLBdnWW9RpTj+ntomjUZdBi9SSWlVVXSwTFsAvp+VDwHq9PtRSAL8c2Xa7xWq1IiXNxLJxFNq2xXq9JiWzcMrGee+xXq9n02iI9XqNzWYz+vNvUae5/JyrE1WjLoOvD7kNtYwxIkd5GWNebKXEPheZkZzPkHiVyE0nSaZqNGpOIbfAIFlaHZApeS5dmj6nsxhzLU3P1Wj0RGOOpzfn5nA5n6yUk05ScDUirT5oYOARHU5i45EGBj6SOknBqf1Kan2u9R7KshRxOGNMcofL+SzGnHS6ZbRCFD5uF83F4XINDLnpdKtohahncnM4DQzTeMuBYVKFKO/ljqKWTDDJxeGkNZJKbspNp1tjUmu992L56gEQOY8hHsiZGimHk9QIkNuqnJtOkSwqRImWWG/yOgw2HsqRWxXlHM9jkNApYovrjkxmsS7pdJIOp+XV+ahOPAJw9aK2s7UwOp1E5l7TNGKnEC0WC3IhEyrR4VLbkdQIUJ24BB9EdeoyOPaqqor0g9571HV9tuNqGISyBOfNyRjg7u4OFT4W+9hut6yOo7Zpu92SKw9x7Oz3ezjnktvp02iIsizJWY9vTac5/HyJwNaJqtHJ94c+QO2w3W6Huq5hrT3ZTVUbi1CUrNkUYwzuqjvEq3HOvZQJo+zaqqqK3KanpycURUHKRORkB65Wqxdno2TtUbMD+zQagprJ+RZ1msvPuTpxsm2PSTK2izPeqSeBJNfipRKOpFclpKo2qU48JHWKJGuRBoZpdnJzONWJj3RgSNqaXAODlB0gfXJOzoFBdeKRfGpYOjDktD4e31dzcjjVaZodCZ1Edkm87Kor0w7pYiVgdTienehwEgFcdeLbSR0YxGYvvPcIEw60DAFYBbzM6DoAa3NeAOM87HIJ15zO2LYwaIi2L9mB8ygWC7j2dLa7MIZ8RN/aGLhztsLzyc1FgeBPf5UaamsY1JfsPC9/2Qvtotp7izptCjut7sORn58jBqCyLFnnJQwhmubofYANh7VYaqetAPyZ83hZ7g4G/rOH3u+Yxd2JHWOeD9UkMGhnedoeA7qdsKwQlqSvAAAs1U5ZHpbMBjjXLhsMQLH3BnUKOAQOKgbjA27ciJYiMIgGBYOAOxNgYUA9hNoD+AB8qip3xxc1IuVmB2Za5s2ttuvW7QxQAKgIPx/nZ6h7M4YQzbwwAB69x0KsqJaivB4WBngP2k2ZIj1ePCh8x3ssNSYoygl3AP4BY94tTtzOtTdDNCgUAL7nPe4TJ5QoymvkMwB/BP47/VybtgbtPz09kX6wqqqLe/E9gD8G8Jcu4JsQ9CVCUZ4xAO5bh+/UW6y8h0H/vXQJ7z1WqxUpd6bL4EhhzvRNA+ARwD82wN+/hSNmFOVG+I73+L5r8S6ESXPA1trJx+EPBoWY1z1HcIhLLj82wD8BkH7riqLcPmUI+L5z+KFrUczwah1TrbkbqUZ9KxqZa9TwfWPwY2PwjyaujCnKa8cA+K73+IF3+C5xv0QfcVWCExhGz2kcjximnjxTAvjSGtQe+DYErHGYb1CUt4QFcB8CvnINftA2KBPMsnHmFsgVooB59ne/A/DPrcG/sxYP0BGD8rYwOASEf9M0+LJt8XBDK3Lk1Y84YrDWTp7hfATwEwsYGPx56/C3xqC90rl0iiJFGQK+6z2+cg1+5D3e4bYeiqwl0fiuMjUwFDjs4PoX1iC0Df7KWPxNUeBbOzGhRFFukLh57/vO4Qfe4Qdtg4cQUFgLTLyX5oS9N3KuwGBxCAw/8R7vQ4svQom/KUqsjMHWGOwN0MDAg7HFX1GuRFxpW5jDTsXPcNiH8H3X4oeuxXedf5lDmOtemotJG6bnbEyJw7LMP/Qeq7bB10WJ31qLb63FH6zFLhiEo+xKA8BY+qArhICh1zeDTwOQZdhBAPyAoRM7hrcc48+kU3ft4MiWMfyVpOCHN50dt+ut6hSTm97jsHX5jwB8p97iXQhnlx1vKTBMzqKIJcnmytQqQsD7EPDPQoMv8VwcA0Dc0mELC+8OB7Y8PPSnyp6j3tWo63r4OsriJf/+/efvyXacc1iv16PseHdIg31498Dapvph9WHwM7HqkHced3d3uKvuyHYAYL1bXzxnoWvvzer0fM8bcxgJGxxutLhT8RJz30tcZkmtinuu50rIMAAWIXQ2Nz33dHvoOBMCaAdzH1ggoAwjInHjX3LVHxl2HAAQ7Dh3mHDi9KAbY+e532ANFgigHZ7+ERMCWoK9N6nThTt/zDhm7nuJw2wJUTGySVS1ibX9UhOP8pKoPCR1+jAgo1G0pzrRkdapy+BIgZqn7ZxjDX2steTKQ23bsjqO2qb9fs/qB+p3mqZhlQuT0ghQnYDb14mqUZfBb1Kr5+x2O2w2G3KVI07lofV6DWMMqeOqqiK3SbLyUNu25NJxnApRHI0A1Qm4fZ1uskKUZJEMAGJDOgk7cYiaeugopRGgOk1BUqdIMktSjYlPBXU4OpIOpzrxkQ4MSa3kGBjislFqcnQ41YmPpE7JLUgGhhBCckdIcVDmJXJ0ONWJj5ROIuMRyTkGKYeTqlV4DYdTnejkFBjEZi80MPCRdjjViUcugUH0NGcNDHwkHU514pNDYBANCoAGhim0bQtrrdiuUdWJh5ROqTQSDwqAvMNJVFGWcjiprcPRlurEQ0qnFBpdJSgAsg4nMQst7XBSCTOqEx8pnebW6GpBAVCHm4IGBj456jSnRoO9slqtaD9Ylnh8pCWxeu+x3W5J37HWku2EELDf78ltotoBDkkzVDvL5RL39/ek77RtK6IRoDpFblknjkYndsd8qG3b8T9YluTIWBQFmqZ5yT5LZQf4OLtOSZrh2InZgZS+u7+/J9uy1qJpmuQaAapT5JZ14mjUZXCsEXPVUyO1LfVwzFf62e6YFZi674wxYhoBqtMUO6/lXhr1AiLVGKlDLHJdBpMKDKoTn9dwL42elZBqjNTETHS41JNnOTocoDpN4dbvJVJP33pjqMQ8f3U4HqoTH8l7iQq5lzUw8MjR4QDVaQqSOlFg9bDkAZaSJwOl3pZ6jT34EqhOfCR1GgtbScknhJTDxQzBlOS4cQZQnaYgqdMYJqmYY2AA5J5EOR1NBqhOU7ilwDBZQcnAIJEdGDd8SDic1Jq/dGBQnXjcSmCYJaxLNSaetS/hCIDcpFZuDqc68bmFwDBrhSiJwyWknxBS6a+SDpfjk1x1mo9ZezLuVU9dvitGbonqvN571lovFecc2rZN3ndSGgGq01Q7Ujp1GZxa5Va1aZqG9D1u5SGqI1RVRW7T09MTjDEkgcqyJNtZrVbkpBlATiNAdQJuX6ebrBDVNA0Wizyngu0AAAReSURBVMXwBydyjffk1EhtaJHSCFCdpiCpUyTZi1iOgQGQqQSco8OpTnykA0PS2ZmmacQ2f5Rlmc0kJyDrcJJbolUnHpI6JZ+yjZ2WWiCpo7VzdDgpjaIt1WmandRtEjmjUcoRJB1OqsyadP69xP4C1WmandR9J3Zwa26BQSprD5BLmol2VCce0jql6jvR05ylA4PE6cOAjMNJlldXnfhI6pRKI/Ej3iUdTqpYKpCXwwGq0xRee2C4St0HSYeTqlcA8E4TppJrYFCdeKTQ6GrFYHIoxHlMjg4HqE5TeK2B4aoVonJzuLiVNyeHA1SnqbZeW2AYXEPZ7XbkH62qinYRZYn9fk9uENWOMQbee3KbOHacc2Q7ZVmSlrW4dgB6mwDVKXLLOnE1+uQ3hj7gnCMlZFRVxXK4zWaDuq5Hf74sS7x7945sp65r1HVNytyjJrIAh37bbDakRCBOIksIgZw0w9UIUJ2A29eJqlGXwXGa1L5ricKiAF5qCEjMQktVOJLcG6868ZDUaapGZ3u8O/SQakzbtmJ2pJbBJBwOkE2aUZ34XPNeGvtKMbq3pRIyJDstR4eTSppRnfjc+r10kxWi1OH4SBYYUZ34SN5LVMi9LHUWvlQ0zdHhpDQCVKcpSOpEgdzD0tVz9ElER1IjQHXiIq3TWFi9K9kY6SGqRNZejg6nOvG4xcDwEhSonSwdGHLJVQfydTjVicc1AkNf300ah+VYoVefRNNQnXjc0ohh8stZjoFBshRejg6nOvG4ZmA4Dq720j9QInCOgUHqFJ1cHU514pFKp0v39rlJ24sjBe4cgwQx/z418UmUusJRdLjUdiQ1AlQnLil0ougwGI4eHx9Jxvf7PTabDbnjlssl7u/vR38+Vh6iltUqy5LcptVqhaIoSLastWQ72+0WTdOQ+05KI0B1Am5fJ6pGXT4JCt2SW8YY8nDJGIO6rlGWJams1v39PdnWZrMh2ynLkmwnPiEAjHY4jh3gMINfFAWpTVIaAapT5JZ16mrUHSUMjRpOXh+48wpdJDe0SGXtSVVrljwVWDKJSnXiMVWnsfe0ff43m3KHmOSGFgmHkyp5DsjNrEtnV6pOPFLoFPuoGyhOFOq+Qnz11Vcn7zTx/7tDtGuUzVaUt8ilV4JuMOz+/5hR1KjzFC4ZOndhx/8pijIPfffWnAEBOBopWGtfRgDxy8dP/uN/PzZ4adRAuQhFUehcCgbn/tYNJt0H++EN4fBvpBe8bmA4/vFzyyb6OqEo83DuAXtp3mTqfEp5PCoYGi1Eg+cCwLkLSb3JQ1HeCmNv9HOfGzNKOOZkpDA2MMS/940GpGaAFeUt0zeHdykg9PESFI5XHc4FBuA0OBwbHAoQiqLMx9Bk/rlRwHFAuDRKAHp2NI4NDGMvcuj7iqIcmDpBf+5ePBcQLlF2XxEuBYZjY9StpN0LVhRlXvqe/JcCwqV78ezrQ19g6F7AcWDQUYCiyDB66zIxICiKopzw/wGUfLbwzgH9ZwAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    width: 500,
    height: 500,
    rx: 15.5,
    ry: 15.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1",
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 60.39,
    y: 188.74,
    width: 351.15,
    height: 99.5,
    rx: 3.04,
    ry: 3.04,
    transform: "translate(-99.53 236.7) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M162.26,376.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M144.42,358.2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 153.25,
    y1: 324.78,
    x2: 183.87,
    y2: 355.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 195.5,
    y1: 282.53,
    x2: 226.12,
    y2: 313.15
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M289.5,249.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M278.72,238.99"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 280,
    y1: 198.03,
    x2: 310.62,
    y2: 228.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 322.25,
    y1: 155.78,
    x2: 352.88,
    y2: 186.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M204.99,334.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M194.21,323.5"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 220.24,
    y1: 224.21,
    x2: 267.89,
    y2: 270.42
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_3",
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M352.29,294.4s54.41-54.4,81.49-81.62c6.17-6.2,12.99-10.64,22.13-10.51,18.88.27,30.91,21.16,21.36,37.44-1.87,3.18-4.35,6.11-6.97,8.73-58.39,58.56-116.78,117.12-175.31,175.54-24.31,24.26-52.14,42.81-86.43,49.58-46.13,9.11-87.67-2.46-123.84-31.36-39.93-31.92-64.14-72.92-64.17-125.49-.02-34.14,13.08-63.82,33.7-90.39,6.29-8.11,13.27-15.77,20.51-23.07,31.82-32.12,56.63-54.41,88.13-86.84,11.26-11.59,28.29-11.64,37.96-1.36,10.14,10.78,9.46,25.72-2.28,37.49-19.68,19.75-60.59,58.47-80.29,78.2l-2.3,2.3c-2.19,2.2-2.23,5.75-.07,7.98,20.66,21.27,41.96,41.81,45.58,71.76,2.85,23.61-6.36,45.61-26.05,67.49-2.13,2.37-2.06,5.98.19,8.24l1.32,1.32c2.1,2.1,5.53,2.07,7.6-.07,20.88-21.63,30.87-40.67,30.12-69.79-1-38.68-19.21-54.46-38.83-76.26-2.79-3.1-2.69-7.84.25-10.8l.32-.34c54.36-54.64,137.11-137.29,191.49-191.9,1.82-1.82,3.65-3.65,5.63-5.29,10.88-8.98,25.59-8.34,34.9,1.45,9.45,9.94,9.55,24.39.22,34.96-1.39,1.58-2.95,3.02-4.44,4.51-38.22,38.27-76.45,76.54-114.67,114.82l-3.46,3.79s-3.09,2.51-.58,5.59l5.16,4.77s2.65,1.69,5.74-.82l3.97-3.49c46.67-46.73,93.27-93.52,140.1-140.08,4.18-4.16,9.45-7.88,14.91-9.97,10.39-3.99,21.96.71,28.21,10.12,6.13,9.22,5.37,21.52-1.93,29.99-1.83,2.13-3.85,4.09-5.84,6.08-46.66,46.73-86.38,86.49-133.03,133.21l-4.24,3.95s-3.86,3.13-.33,7.77l2.51,3.09s3.37,3.85,8,.09l4.5-4.18s75.8-75.94,117.21-117.35c11.26-11.26,25.71-12.91,35.88-4.25,12.34,10.5,13.11,26.64,1.82,38.31-1.79,1.85-3.63,3.66-5.45,5.48-40.23,40.28-80.46,80.56-120.68,120.84l-3.76,3.77s-4.77,5.16-2.26,8.25l3.76,4.63s2.51,3.09,7.14-.68"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_5",
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 15.18,
    y: 182.99,
    width: 470.53,
    height: 133.33,
    rx: 3.04,
    ry: 3.04,
    transform: "translate(-103.18 250.21) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M151.69,433.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M127.78,410.06"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 139.61,
    y1: 365.28,
    x2: 180.64,
    y2: 406.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 196.23,
    y1: 308.66,
    x2: 237.26,
    y2: 349.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M322.18,264.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M307.74,250.33"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 309.46,
    y1: 195.43,
    x2: 350.49,
    y2: 236.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 366.07,
    y1: 138.82,
    x2: 407.11,
    y2: 179.85
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M208.95,378"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M194.51,363.56"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 229.38,
    y1: 230.51,
    x2: 293.23,
    y2: 292.43
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_6",
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M243.67,26.89l-62.48,108.22c-4.59,7.95,1.15,17.89,10.33,17.89h124.96c9.18,0,14.92-9.94,10.33-17.89l-62.48-108.22c-4.59-7.95-16.07-7.95-20.66,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M473.78,239.67l-108.22-62.48c-7.95-4.59-17.89,1.15-17.89,10.33v124.96c0,9.18,9.94,14.92,17.89,10.33l108.22-62.48c7.95-4.59,7.95-16.07,0-20.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M264,473.68l62.48-108.22c4.59-7.95-1.15-17.89-10.33-17.89h-124.96c-9.18,0-14.92,9.94-10.33,17.89l62.48,108.22c4.59,7.95,16.07,7.95,20.66,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M26.56,260.33l108.22,62.48c7.95,4.59,17.89-1.15,17.89-10.33v-124.96c0-9.18-9.94-14.92-17.89-10.33l-108.22,62.48c-7.95,4.59-7.95,16.07,0,20.66Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_7",
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-22",
    cx: 278.83,
    cy: 257.88,
    r: 49.92
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M205.03,112.86l-28.55,31.2h-60.46c-17.16,0-31.2,14.04-31.2,31.2v167.22c0,17.16,14.04,31.2,31.2,31.2h260.62c17.16,0,31.2-14.04,31.2-31.2v-167.22c0-17.16-14.04-31.2-31.2-31.2h-49.46l-28.55-31.2h-93.61ZM279.02,356.46c-54.55,0-98.82-44.27-98.82-98.82s44.27-98.82,98.82-98.82,98.82,44.27,98.82,98.82-44.27,98.82-98.82,98.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M136,37.5h-66s-32.5-1-32.5,32.5v61.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M363.98,462.36h66s32.5,1,32.5-32.5v-61.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M462.15,135.87v-66s1-32.5-32.5-32.5h-61.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37.3,363.85v66s-1,32.5,32.5,32.5h61.5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_9",
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 124.73,
    y1: 361.07,
    x2: 375.27,
    y2: 361.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 181.33,
    y1: 415.35,
    x2: 318.67,
    y2: 415.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 72.5,
    y1: 306.05,
    x2: 427.5,
    y2: 306.05
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 36.92,
    y1: 250,
    x2: 44.42,
    y2: 250
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 91.14,
    y1: 250,
    x2: 432.22,
    y2: 250
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 455.58,
    y1: 250,
    x2: 463.08,
    y2: 250
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-10",
    transform: "translate(-2098.09 -894.19)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "v")), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M249,49c-78.92,0-142.95,63.71-143.49,142.5h286.97c-.54-78.79-64.57-142.5-143.49-142.5Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M239.67,71.38l-62.48,108.22c-4.59,7.95,1.15,17.89,10.33,17.89h124.96c9.18,0,14.92-9.94,10.33-17.89l-62.48-108.22c-4.59-7.95-16.07-7.95-20.66,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M260.33,428.61l62.48-108.22c4.59-7.95-1.15-17.89-10.33-17.89h-124.96c-9.18,0-14.92,9.94-10.33,17.89l62.48,108.22c4.59,7.95,16.07,7.95,20.66,0Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 85.25,
    y1: 250,
    x2: 414.75,
    y2: 250
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_12",
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 163.61,
    y1: 334.75,
    x2: 370,
    y2: 128.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-22",
    cx: 398.17,
    cy: 106.63,
    r: 43.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-22",
    cx: 99.9,
    cy: 394.75,
    r: 43.14
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_13",
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1012.22,525.82l-271.02-156.47c-7.95-4.59-17.89,1.15-17.89,10.33v312.95c0,9.18,9.94,14.92,17.89,10.33l271.02-156.47c7.95-4.59,7.95-16.07,0-20.66Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M754.74-146.56h45.32v-55.15c0-14.16-11.48-25.65-25.65-25.65h-75.14v-39.44c0-9.18-9.94-14.92-17.89-10.33l-188.69,108.94c-7.95,4.59-7.95,16.07,0,20.66l188.69,108.94c7.95,4.59,17.89-1.15,17.89-10.33v-39.44h29.82v-32.56c0-14.16,11.48-25.65,25.65-25.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1036.46-87.38l-188.69-108.94c-7.95-4.59-17.89,1.15-17.89,10.33v39.44h-29.82v32.56c0,14.16-11.48,25.65-25.65,25.65h-45.32v55.15c0,14.16,11.48,25.65,25.65,25.65h75.14V31.88c0,9.18,9.94,14.92,17.89,10.33l188.69-108.94c7.95-4.59,7.95-16.07,0-20.66Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M878.7,347.48l188.69,108.94c7.95,4.59,17.89-1.15,17.89-10.33v-217.88c0-9.18-9.94-14.92-17.89-10.33l-188.69,108.94c-7.95,4.59-7.95,16.07,0,20.66Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 1017.07,
    y: 267.65,
    width: 169,
    height: 139,
    rx: 25.65,
    ry: 25.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1444.52,258.67l-188.69-108.94c-7.95-4.59-17.89,1.15-17.89,10.33v217.88c0,9.18,9.94,14.92,17.89,10.33l188.69-108.94c7.95-4.59,7.95-16.07,0-20.66Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 1137.15,
    y: 199.5,
    width: 169,
    height: 139,
    rx: 25.65,
    ry: 25.65,
    transform: "translate(2443.31 538) rotate(180)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M229.95,258.13v-35.92s-41.21-.01-41.21-.01v-31.34c.01-7.3-7.88-11.86-14.2-8.21L24.57,269.16c-6.32,3.65-6.32,12.76,0,16.41l149.91,86.62c6.32,3.65,14.22-.91,14.22-8.2v-31.34s59.72.02,59.72.02c11.26,0,20.38-9.12,20.39-20.37v-33.78s-18.48,0-18.48,0c-11.25,0-20.38-9.13-20.37-20.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M474.2,215.16l-149.91-86.62c-6.32-3.65-14.22.91-14.22,8.2v31.34s-59.72-.02-59.72-.02c-11.25,0-20.38,9.12-20.39,20.37v33.78s18.48,0,18.48,0c11.25,0,20.38,9.13,20.37,20.39v35.92s41.21.01,41.21.01v31.34c-.01,7.3,7.88,11.86,14.2,8.21l149.97-86.52c6.32-3.65,6.32-12.76,0-16.41Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_14",
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M1012.52-2.64c-166.64-37.13-312.1,108.34-274.98,274.98,18.88,84.73,85.4,151.26,170.14,170.14,166.64,37.13,312.1-108.34,274.98-274.98-18.88-84.73-85.4-151.26-170.14-170.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M962.66,402.62c-102.75,1.42-186.68-82.52-185.27-185.27,1.36-98.54,81.6-178.78,180.14-180.14,102.75-1.42,186.68,82.52,185.27,185.27s-81.6,178.78-180.14,180.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M645.92,78.42h0c18.42,0,33.36,11.44,33.36,25.55v102.19c0,14.11-14.94,25.55-33.36,25.55h0c-18.42,0-33.36-11.44-33.36-25.55v-102.19c0-14.11,14.94-25.55,33.36-25.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M732.19-73.06h0c0,18.42-14.94,33.36-33.36,33.36h-133.43c-18.42,0-33.36-14.94-33.36-33.36h0c0-18.42,14.94-33.36,33.36-33.36h133.43c18.42,0,33.36,14.94,33.36,33.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M855.29-265.2h-33.36v-33.36c0-18.42-14.94-33.36-33.36-33.36h0c-18.42,0-33.36,14.94-33.36,33.36v33.36h-33.36c-18.42,0-33.36,14.94-33.36,33.36h0c0,18.42,14.94,33.36,33.36,33.36h33.36v33.36c0,18.42,14.94,33.36,33.36,33.36h0c18.42,0,33.36-14.94,33.36-33.36v-33.36h33.36c18.42,0,33.36-14.93,33.36-33.36h0c0-18.42-14.94-33.36-33.36-33.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M722.56,155.06h0c0,18.42-11.44,33.36-25.55,33.36h-102.19c-14.11,0-25.55-14.94-25.55-33.36h0c0-18.42,11.44-33.36,25.55-33.36h102.19c14.11,0,25.55,14.94,25.55,33.36Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M1508,1018.76h0c18.42,0,33.36,14.94,33.36,33.36h0c0,18.42-14.94,33.36-33.36,33.36h0c-18.42,0-33.36-14.94-33.36-33.36h0c0-18.42,14.94-33.36,33.36-33.36ZM1508,1108.38h0c18.42,0,33.36,14.94,33.36,33.36v133.43c0,18.42-14.94,33.36-33.36,33.36h0c-18.42,0-33.36-14.94-33.36-33.36v-133.43c0-18.42,14.94-33.36,33.36-33.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M1730.56,1114.58c-18.88-84.73-85.4-151.26-170.14-170.14-166.64-37.13-312.1,108.34-274.98,274.98,18.88,84.73,85.4,151.26,170.14,170.14,166.64,37.13,312.1-108.34,274.98-274.98ZM1690.7,1169.56c-1.36,98.54-81.6,178.78-180.14,180.14-102.75,1.42-186.68-82.52-185.27-185.27,1.36-98.54,81.6-178.78,180.14-180.14,102.75-1.42,186.68,82.52,185.27,185.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M1632.57,972.51h0c18.42,0,33.36,11.44,33.36,25.55v102.19c0,14.11-14.94,25.55-33.36,25.55h0c-18.42,0-33.36-11.44-33.36-25.55v-102.19c0-14.11,14.94-25.55,33.36-25.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M1709.22,1049.15h0c0,18.42-11.44,33.36-25.55,33.36h-102.19c-14.11,0-25.55-14.94-25.55-33.36h0c0-18.42,11.44-33.36,25.55-33.36h102.19c14.11,0,25.55,14.94,25.55,33.36Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M1491.57,514.91h0c18.42,0,33.36,14.94,33.36,33.36h0c0,18.42-14.94,33.36-33.36,33.36h0c-18.42,0-33.36-14.94-33.36-33.36h0c0-18.42,14.94-33.36,33.36-33.36ZM1491.57,604.53h0c18.42,0,33.36,14.94,33.36,33.36v133.43c0,18.42-14.94,33.36-33.36,33.36h0c-18.42,0-33.36-14.94-33.36-33.36v-133.43c0-18.42,14.94-33.36,33.36-33.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M1714.13,610.73c-18.88-84.73-85.4-151.26-170.14-170.14-166.64-37.13-312.1,108.34-274.98,274.98,18.88,84.73,85.4,151.26,170.14,170.14,166.64,37.13,312.1-108.34,274.98-274.98ZM1674.28,665.72c-1.36,98.54-81.6,178.78-180.14,180.14-102.75,1.42-186.68-82.52-185.27-185.27,1.36-98.54,81.6-178.78,180.14-180.14,102.75-1.42,186.68,82.52,185.27,185.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M1636.14,468.66h0c18.42,0,33.36,11.44,33.36,25.55v102.19c0,14.11-14.94,25.55-33.36,25.55h0c-18.42,0-33.36-11.44-33.36-25.55v-102.19c0-14.11,14.94-25.55,33.36-25.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M1712.79,545.31h0c0,18.42-11.44,33.36-25.55,33.36h-102.19c-14.11,0-25.55-14.94-25.55-33.36h0c0-18.42,11.44-33.36,25.55-33.36h102.19c14.11,0,25.55,14.94,25.55,33.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M2030.41,515.3h0c18.42,0,33.36,14.94,33.36,33.36h0c0,18.42-14.94,33.36-33.36,33.36h0c-18.42,0-33.36-14.94-33.36-33.36h0c0-18.42,14.94-33.36,33.36-33.36ZM2030.41,604.92h0c18.42,0,33.36,14.94,33.36,33.36v133.43c0,18.42-14.94,33.36-33.36,33.36h0c-18.42,0-33.36-14.94-33.36-33.36v-133.43c0-18.42,14.94-33.36,33.36-33.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M2252.97,611.12c-18.88-84.73-85.4-151.26-170.14-170.14-166.64-37.13-312.1,108.34-274.98,274.98,18.88,84.73,85.4,151.26,170.14,170.14,166.64,37.13,312.1-108.34,274.98-274.98ZM2213.11,666.1c-1.36,98.54-81.6,178.78-180.14,180.14-102.75,1.42-186.68-82.52-185.27-185.27,1.36-98.54,81.6-178.78,180.14-180.14,102.75-1.42,186.68,82.52,185.27,185.27Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M2228.08,512.34h-17.74v-17.74c0-14.11-14.94-25.55-33.36-25.55h0c-18.42,0-33.36,11.44-33.36,25.55v17.74h-17.74c-14.11,0-25.55,14.94-25.55,33.36h0c0,18.42,11.44,33.36,25.55,33.36h17.74v17.74c0,14.11,14.94,25.55,33.36,25.55h0c18.42,0,33.36-11.44,33.36-25.55v-17.74h17.74c14.11,0,25.55-14.94,25.55-33.36h0c0-18.42-11.44-33.36-25.55-33.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M2176.98,469.05c18.42,0,33.36,11.44,33.36,25.55v17.74h17.74c14.11,0,25.55,14.93,25.55,33.36h0c0,18.42-11.44,33.36-25.55,33.36h-17.74v17.74c0,14.11-14.94,25.55-33.36,25.55h0c-18.42,0-33.36-11.44-33.36-25.55v-17.74h-17.74c-14.11,0-25.55-14.94-25.55-33.36h0c0-18.42,11.44-33.36,25.55-33.36h17.74v-17.74c0-14.11,14.94-25.55,33.36-25.55h0M2176.98,434.05c-16.56,0-32.5,5.22-44.87,14.7-10.57,8.1-17.95,18.85-21.36,30.72-11.87,3.41-22.62,10.78-30.72,21.36-9.48,12.37-14.7,28.31-14.7,44.87s5.22,32.5,14.7,44.87c8.1,10.57,18.85,17.95,30.72,21.36,3.41,11.87,10.78,22.62,21.36,30.72,12.37,9.48,28.31,14.7,44.87,14.7s32.5-5.22,44.87-14.7c10.57-8.1,17.95-18.85,21.36-30.72,11.87-3.41,22.62-10.78,30.72-21.36,9.48-12.37,14.7-28.31,14.7-44.87s-5.22-32.5-14.7-44.87c-8.1-10.57-18.85-17.95-30.72-21.36-3.41-11.87-10.78-22.62-21.36-30.72-12.37-9.48-28.31-14.7-44.87-14.7h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M2578.58,511.03h0c18.42,0,33.36,14.94,33.36,33.36h0c0,18.42-14.94,33.36-33.36,33.36h0c-18.42,0-33.36-14.94-33.36-33.36h0c0-18.42,14.94-33.36,33.36-33.36ZM2578.58,600.65h0c18.42,0,33.36,14.94,33.36,33.36v133.43c0,18.42-14.94,33.36-33.36,33.36h0c-18.42,0-33.36-14.94-33.36-33.36v-133.43c0-18.42,14.94-33.36,33.36-33.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M2637.88,486.45c-19.37-6.67-40.2-10.18-61.87-9.88-98.54,1.36-178.78,81.6-180.14,180.14-1.42,102.75,82.52,186.68,185.27,185.27,98.54-1.36,178.78-81.6,180.14-180.14.08-5.89-.13-11.72-.6-17.48,0,0,28.32-2.36,39.82-40.22.21.9.43,1.81.63,2.71,37.13,166.63-108.34,312.1-274.98,274.98-84.73-18.88-151.26-85.4-170.14-170.14-37.13-166.63,108.34-312.1,274.98-274.98,14.7,3.27,28.85,7.99,42.3,13.98,0,0-24.3,10.31-35.41,35.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M2776.25,508.07h-17.74v-17.74c0-14.11-14.94-25.55-33.36-25.55h0c-18.42,0-33.36,11.44-33.36,25.55v17.74h-17.74c-14.11,0-25.55,14.94-25.55,33.36h0c0,18.42,11.44,33.36,25.55,33.36h17.74v17.74c0,14.11,14.94,25.55,33.36,25.55h0c18.42,0,33.36-11.44,33.36-25.55v-17.74h17.74c14.11,0,25.55-14.94,25.55-33.36h0c0-18.42-11.44-33.36-25.55-33.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M250,101.76h0c18.42,0,33.36,14.94,33.36,33.36h0c0,18.42-14.94,33.36-33.36,33.36h0c-18.42,0-33.36-14.94-33.36-33.36h0c0-18.42,14.94-33.36,33.36-33.36ZM250,191.38h0c18.42,0,33.36,14.94,33.36,33.36v133.43c0,18.42-14.94,33.36-33.36,33.36h0c-18.42,0-33.36-14.94-33.36-33.36v-133.43c0-18.42,14.94-33.36,33.36-33.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M309.3,77.18c-19.37-6.67-40.2-10.18-61.87-9.88-98.54,1.36-178.78,81.6-180.14,180.14-1.42,102.75,82.52,186.68,185.27,185.27,98.54-1.36,178.78-81.6,180.14-180.14.08-5.89-.13-11.72-.6-17.48,0,0,28.32-2.36,39.82-40.22.21.9.43,1.81.63,2.71,37.13,166.63-108.34,312.1-274.98,274.98-84.73-18.88-151.26-85.4-170.14-170.14C-9.68,135.78,135.78-9.68,302.42,27.44c14.7,3.27,28.85,7.99,42.3,13.98,0,0-24.3,10.31-35.41,35.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M447.67,98.8h-17.74v-17.74c0-14.11-14.94-25.55-33.36-25.55h0c-18.42,0-33.36,11.44-33.36,25.55v17.74h-17.74c-14.11,0-25.55,14.94-25.55,33.36h0c0,18.42,11.44,33.36,25.55,33.36h17.74v17.74c0,14.11,14.94,25.55,33.36,25.55h0c18.42,0,33.36-11.44,33.36-25.55v-17.74h17.74c14.11,0,25.55-14.94,25.55-33.36h0c0-18.42-11.44-33.36-25.55-33.36Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_15",
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 629.86,
    y: -192.94,
    width: 459.24,
    height: 290.55,
    rx: 25.65,
    ry: 25.65,
    transform: "translate(907.15 811.82) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1081.91-56.36l-188.69-108.94c-7.95-4.59-17.89,1.15-17.89,10.33V62.9c0,9.18,9.94,14.92,17.89,10.33l188.69-108.94c7.95-4.59,7.95-16.07,0-20.66Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 774.55,
    y: -115.54,
    width: 169,
    height: 139,
    rx: 25.65,
    ry: 25.65,
    transform: "translate(1718.09 -92.07) rotate(180)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M876.85,564.48v-39.44s-75.14,0-75.14,0c-14.16,0-25.65-11.48-25.65-25.65v-87.71c0-14.16,11.48-25.65,25.65-25.65h75.14s0-39.44,0-39.44c0-9.18,9.94-14.92,17.89-10.33l111.54,64.4v-150.74c0-14.16-11.48-25.65-25.65-25.65h-239.26c-14.16,0-25.65,11.48-25.65,25.64v407.95c0,14.16,11.48,25.65,25.64,25.65h239.26c14.16,0,25.65-11.48,25.65-25.64v-147.47s-111.54,64.4-111.54,64.4c-7.95,4.59-17.89-1.15-17.89-10.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1083.43,445.22l-77.15-44.54v109.74s77.15-44.54,77.15-44.54c7.95-4.59,7.95-16.07,0-20.66Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1688.85,457.97l-43.12,21.76-371.06,181.4v150.91l350.91-285,71.02-57.04c2.86-2.31,3.53-6.41,1.54-9.5-1.36-2.12-3.67-3.3-6.05-3.3-1.09,0-2.2.24-3.24.78"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-28"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 1210.4,
    y: 362.22,
    width: 554.01,
    height: 544.79,
    transform: "translate(-62.38 1096.45) rotate(-39.7)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1732.81,508.57l-48.18,42.96-409.96,364.51v271.24l415.43-596.03,53.3-73.07c2.17-2.98,1.76-7.11-.97-9.58-1.37-1.24-3.11-1.86-4.83-1.86s-3.43.6-4.79,1.82"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 1111.62,
    y: 434.81,
    width: 797.02,
    height: 824.4,
    transform: "translate(-192.81 1159.94) rotate(-39.7)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1714.29,480.27l-108.15,83.31-331.47,249.13v107.41l375.72-360.5,73.21-68.39c2.79-2.63,3.06-6.99.57-9.91-1.42-1.67-3.45-2.54-5.49-2.54-1.53,0-3.08.49-4.39,1.5"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M1762.5,443.42l28.15,31.22,177.56-159.89c14.5-13.12,17.04-18.31,21.17-26.99,3.17-6.56,7.09-14.82,16.61-28.36,17.24-24.34,10.16-35.87,10.05-35.98l-.74-.74c-3.06-2.33-15.24-5.71-36.72,6.35-14.39,8.04-22.96,11.12-29.94,13.55-9.1,3.17-14.6,5.19-29.1,18.2l-177.46,159.9,20.42,22.75ZM1789.38,497.71l-51.43-57.04-19.05-21.17,189.85-170.9c16.93-15.24,24.34-17.88,34.6-21.48,6.67-2.33,14.18-5.08,27.41-12.38,33.12-18.63,52.27-8.47,57.35-2.54,5.5,5.82,13.33,25.6-8.68,56.61-8.78,12.38-12.17,19.58-15.24,25.93-4.65,9.83-8.04,16.93-24.97,32.17l-189.85,170.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M1984.73,254.11c-.53-.95-1.37-1.91-2.33-2.65-7.4-5.71-19.89-8.57-32.91.11l-6.88,4.65,33.22,36.83,5.3-6.35c9.95-11.96,8.47-24.66,3.6-32.59"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M1696.9,391.78l23.49,26.14,123.38-111.85-39.47,2.96-107.41,82.75ZM1719.22,441.09l-46.35-51.43,125.4-96.51,91.95-6.98-171,154.92ZM1791.29,496.44l23.49,26.14,93.55-98.2,7.09-38.94-124.12,111ZM1814.46,546.6l-46.35-51.43,171.95-153.87-16.61,90.69-109,114.61Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "1832.45 448.29 1773.19 382.47 1732.13 419.5 1791.18 485.12 1832.45 448.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M1743.67,420.14l48.14,53.44,29.1-25.93-48.25-53.66-28.99,26.14ZM1790.54,496.65l-69.95-77.67,53.23-47.94,70.16,77.99-53.44,47.62Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1798.97-282.89l-43.12,21.76-371.06,181.4V71.18l350.91-285,71.02-57.04c2.86-2.31,3.53-6.41,1.54-9.5-1.36-2.12-3.67-3.3-6.05-3.3-1.09,0-2.2.24-3.24.78"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 1320.51,
    y: -378.64,
    width: 554.01,
    height: 544.79,
    transform: "translate(436.25 995.94) rotate(-39.7)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1842.93-232.29l-48.18,42.96-409.96,364.51v271.24l415.43-596.03,53.3-73.07c2.17-2.98,1.76-7.11-.97-9.58-1.37-1.24-3.11-1.86-4.83-1.86s-3.43.6-4.79,1.82"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 1221.73,
    y: -306.04,
    width: 797.02,
    height: 824.4,
    transform: "translate(305.82 1059.44) rotate(-39.7)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1824.41-260.58l-108.15,83.31-331.47,249.13v107.41l375.72-360.5,73.21-68.39c2.79-2.63,3.06-6.99.57-9.91-1.42-1.67-3.45-2.54-5.49-2.54-1.53,0-3.08.49-4.39,1.5"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M2094.84-486.75c-.53-.95-1.37-1.91-2.33-2.65-7.4-5.71-19.89-8.57-32.91.11l-6.88,4.65,33.22,36.83,5.3-6.35c9.95-11.96,8.47-24.66,3.6-32.59"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M2138.23-528.65c-5.08-5.93-24.23-16.09-57.35,2.54-13.23,7.3-20.74,10.05-27.41,12.38-10.26,3.6-17.67,6.24-34.6,21.48l-43.87,39.5-66.6,5.05-125.4,96.51,46.35,51.43,10.53-9.54,8.21,9.12,40.66,45.1-10.5,9.4,46.35,51.43,108.99-114.61,12.04-65.74,43.73-39.34c16.93-15.24,20.32-22.33,24.97-32.17,3.06-6.35,6.45-13.55,15.24-25.93,22.01-31.01,14.18-50.79,8.68-56.61ZM1914.42-431.83l39.47-2.96-123.38,111.85-23.49-26.14,107.41-82.75ZM2018.44-316.49l-93.55,98.2-23.49-26.14,124.12-111-7.09,38.94ZM2116.11-481.46c-9.53,13.54-13.44,21.8-16.61,28.36-4.13,8.68-6.67,13.86-21.17,26.99l-135.38,121.9-48.57-53.99,135.27-121.88c14.5-13.01,20-15.03,29.1-18.2,6.98-2.43,15.55-5.5,29.94-13.55,21.48-12.06,33.66-8.68,36.72-6.35l.74.74c.11.11,7.19,11.64-10.05,35.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M471.78,42.83c-6.45-7.53-30.77-20.43-72.84,3.23-16.8,9.27-26.34,12.76-34.81,15.73-13.03,4.57-22.44,7.92-43.94,27.27l-55.72,50.16-84.59,6.42L20.62,268.21l58.86,65.31,13.37-12.11,10.42,11.58,51.64,57.28-13.34,11.94,58.86,65.31,138.43-145.56,15.29-83.49,55.54-49.96c21.5-19.35,25.8-28.36,31.72-40.85,3.89-8.07,8.2-17.21,19.35-32.93,27.95-39.38,18.01-64.51,11.02-71.9ZM187.54,165.8l50.13-3.76-156.7,142.06-29.83-33.2,136.41-105.1ZM319.65,312.29l-118.81,124.72-29.83-33.2,157.64-140.98-9,49.45ZM443.7,102.77c-12.1,17.2-17.07,27.69-21.1,36.02-5.24,11.02-8.47,17.61-26.88,34.27l-171.93,154.82-61.69-68.57,171.8-154.79c18.41-16.53,25.4-19.09,36.96-23.12,8.86-3.09,19.75-6.99,38.03-17.21,27.28-15.31,42.74-11.02,46.64-8.06l.94.94c.14.14,9.14,14.78-12.76,45.7Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1781.47-985.01l-46.46,23.44-399.78,195.44v162.59l378.07-307.06,76.51-61.45c3.08-2.49,3.81-6.91,1.66-10.24-1.46-2.29-3.95-3.56-6.52-3.56-1.18,0-2.37.26-3.49.84"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 1265.98,
    y: -1088.17,
    width: 596.89,
    height: 586.95,
    transform: "translate(868.38 816.05) rotate(-39.7)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1828.83-930.49l-51.91,46.29-441.69,392.72V-199.25l447.59-642.16,57.43-78.72c2.34-3.21,1.89-7.66-1.05-10.32-1.48-1.34-3.35-2.01-5.21-2.01s-3.7.65-5.16,1.96"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 1159.55,
    y: -1009.96,
    width: 858.71,
    height: 888.21,
    transform: "translate(727.85 884.46) rotate(-39.7)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1808.88-960.98l-116.52,89.76-357.13,268.42v115.72l404.8-388.41,78.88-73.68c3.01-2.83,3.29-7.53.61-10.68-1.53-1.8-3.71-2.74-5.91-2.74-1.65,0-3.32.53-4.73,1.61"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M2100.24-1204.65c-.57-1.02-1.48-2.05-2.51-2.85-7.98-6.15-21.43-9.23-35.45.12l-7.41,5.02,35.8,39.68,5.7-6.84c10.72-12.88,9.12-26.56,3.88-35.11"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M2146.99-1249.79c-5.47-6.39-26.11-17.33-61.79,2.74-14.25,7.87-22.35,10.83-29.53,13.34-11.05,3.88-19.04,6.72-37.28,23.14l-47.27,42.55-71.76,5.45-135.1,103.98,49.93,55.41,11.34-10.28,8.84,9.82,43.81,48.59-11.32,10.13,49.93,55.41,117.43-123.48,12.97-70.82,47.11-42.39c18.24-16.42,21.89-24.06,26.9-34.66,3.3-6.84,6.95-14.6,16.42-27.94,23.71-33.41,15.28-54.72,9.35-60.99ZM1905.85-1145.47l42.52-3.19-132.93,120.51-25.31-28.16,115.72-89.15ZM2017.93-1021.21l-100.79,105.8-25.31-28.16,133.73-119.59-7.64,41.95ZM2123.16-1198.95c-10.26,14.59-14.48,23.49-17.9,30.56-4.45,9.35-7.19,14.94-22.8,29.07l-145.85,131.33-52.33-58.17,145.74-131.31c15.62-14.02,21.55-16.19,31.35-19.61,7.52-2.62,16.76-5.93,32.26-14.6,23.15-12.99,36.26-9.35,39.56-6.84l.8.8c.12.12,7.75,12.54-10.83,38.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M412.11,137.44c12.64-15.19,10.75-31.31,4.57-41.39-.68-1.21-1.75-2.42-2.96-3.36-9.4-7.25-25.26-10.88-41.79.14l-8.74,5.91,42.2,46.77,6.72-8.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1174.81-872.39c-5.47-6.39-26.11-17.33-61.79,2.74-14.25,7.87-22.35,10.83-29.53,13.34-11.05,3.88-19.04,6.72-37.28,23.14l-47.27,42.55-71.76,5.45-135.1,103.98,49.93,55.41,11.34-10.28,8.84,9.82,43.81,48.59-11.32,10.13,49.93,55.41,117.43-123.48,12.97-70.82,47.11-42.39c18.24-16.42,21.89-24.06,26.9-34.66,3.3-6.84,6.95-14.6,16.42-27.94,23.71-33.41,15.28-54.72,9.35-60.99ZM933.67-768.07l42.52-3.19-132.93,120.51-25.31-28.16,115.72-89.15ZM1045.75-643.8l-100.79,105.8-25.31-28.16,133.73-119.59-7.64,41.95ZM1150.98-821.54c-10.26,14.59-14.48,23.49-17.9,30.56-4.45,9.35-7.19,14.94-22.8,29.07l-145.85,131.33-52.33-58.17,145.74-131.31c15.62-14.02,21.55-16.19,31.35-19.61,7.52-2.62,16.76-5.93,32.26-14.6,23.15-12.99,36.26-9.35,39.56-6.84l.8.8c.12.12,7.75,12.54-10.83,38.76Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 701.93,
    y1: -434.83,
    x2: 701.93,
    y2: -480.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 701.93,
    y1: -415.38,
    x2: 701.93,
    y2: -434.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 701.93,
    y1: -480.1,
    x2: 701.93,
    y2: -501.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M846.73-571.77c3.01-2.83,3.29-7.53.61-10.68-1.53-1.8-3.71-2.74-5.91-2.74-1.65,0-3.32.53-4.73,1.61l-116.52,89.76-18.25,13.72v45.26l65.92-63.25,78.88-73.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M817.64-594.64c3.09-2.49,3.81-6.91,1.66-10.24-1.47-2.29-3.95-3.56-6.52-3.56-1.18,0-2.37.26-3.49.84l-46.46,23.44-60.9,29.77v53.03l39.19-31.83,76.51-61.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M868.07-542.72c2.34-3.21,1.89-7.66-1.05-10.32-1.48-1.34-3.35-2.01-5.21-2.01s-3.7.65-5.16,1.96l-51.91,46.29-102.81,91.41v14.14h64.97l43.74-62.75,57.43-78.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1124.19-792.13c10.72-12.88,9.12-26.56,3.88-35.11-.57-1.02-1.48-2.05-2.51-2.85-7.98-6.15-21.43-9.23-35.45.12l-7.41,5.02,35.8,39.68,5.7-6.84Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_16",
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "611.62 265.86 611.62 -114.49 906.86 -214.18 906.86 155.38"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 617.37,
    y1: 267.78,
    x2: 904.95,
    y2: 152.75
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "1107.71 455.35 895.98 541.75 683.82 455.35 895.98 377.06 1107.71 455.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M736,407.95v38.13c0,5.47,4.44,9.91,9.91,9.91h38.13c2.63,0,5.15-1.04,7.01-2.9l143.9-143.9c3.87-3.87,3.87-10.15,0-14.02l-38.13-38.13c-3.87-3.87-10.15-3.87-14.02,0l-143.9,143.9c-1.86,1.86-2.9,4.38-2.9,7.01ZM975.29,268.86c9.29-9.29,9.29-24.34,0-33.63l-18.52-18.52c-9.29-9.29-24.34-9.29-33.63,0l-11.43,11.43c-3.87,3.87-3.87,10.15,0,14.02l38.13,38.13c3.87,3.87,10.15,3.87,14.02,0l11.43-11.43Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1877.91 106.32 1695.71 180.67 1513.13 106.32 1695.71 38.94 1877.91 106.32"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1513.13,
    y1: 106.32,
    x2: 1513.13,
    y2: -110.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1513.83,
    y1: -110.99,
    x2: 1696.4,
    y2: -178.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1696.46,
    y1: 39.7,
    x2: 1696.46,
    y2: -177.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1632.29-58.09l176.14,101.7c7.95,4.59,17.89-1.15,17.89-10.33v-203.39c0-9.18-9.94-14.92-17.89-10.33l-176.14,101.7c-7.95,4.59-7.95,16.07,0,20.66Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1877.91 527.32 1695.71 601.67 1513.13 527.32 1695.71 459.94 1877.91 527.32"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1513.13,
    y1: 527.32,
    x2: 1513.13,
    y2: 310.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1513.83,
    y1: 310.01,
    x2: 1696.4,
    y2: 242.63
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1696.46,
    y1: 460.7,
    x2: 1696.46,
    y2: 243.95
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1593.71,386.21l-176.14-101.7c-7.95-4.59-17.89,1.15-17.89,10.33v203.39c0,9.18,9.94,14.92,17.89,10.33l176.14-101.7c7.95-4.59,7.95-16.07,0-20.66Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "2478.91 106.32 2296.71 180.67 2114.13 106.32 2296.71 38.94 2478.91 106.32"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2114.13,
    y1: 106.32,
    x2: 2114.13,
    y2: -110.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2114.83,
    y1: -110.99,
    x2: 2297.4,
    y2: -178.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2297.46,
    y1: 39.7,
    x2: 2297.46,
    y2: -177.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M2233.29-58.09l176.14,101.7c7.95,4.59,17.89-1.15,17.89-10.33v-203.39c0-9.18-9.94-14.92-17.89-10.33l-176.14,101.7c-7.95,4.59-7.95,16.07,0,20.66Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "2478.91 527.32 2296.71 601.67 2114.13 527.32 2296.71 459.94 2478.91 527.32"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2114.13,
    y1: 527.32,
    x2: 2114.13,
    y2: 310.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2114.83,
    y1: 310.01,
    x2: 2297.4,
    y2: 242.63
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2297.46,
    y1: 460.7,
    x2: 2297.46,
    y2: 243.95
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M2194.71,386.21l-176.14-101.7c-7.95-4.59-17.89,1.15-17.89,10.33v203.39c0,9.18,9.94,14.92,17.89,10.33l176.14-101.7c7.95-4.59,7.95-16.07,0-20.66Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1620.36,
    y1: 1256.96,
    x2: 1620.36,
    y2: 1040.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1713.36,
    y1: 1222.96,
    x2: 1713.36,
    y2: 1006.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1621.05,
    y1: 1039.65,
    x2: 1803.62,
    y2: 972.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1621.05,
    y1: 1150.65,
    x2: 1803.62,
    y2: 1083.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1621.05,
    y1: 1257.65,
    x2: 1803.62,
    y2: 1190.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1803.69,
    y1: 1190.34,
    x2: 1803.69,
    y2: 973.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1620.36,
    y1: 1787.96,
    x2: 1620.36,
    y2: 1441.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1745.36,
    y1: 1615.96,
    x2: 1745.36,
    y2: 1579.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1621.05,
    y1: 1440.65,
    x2: 1803.62,
    y2: 1373.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1712.05,
    y1: 1590.65,
    x2: 1745.22,
    y2: 1578.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1621.05,
    y1: 1798.65,
    x2: 1803.62,
    y2: 1731.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1803.69,
    y1: 1721.34,
    x2: 1803.69,
    y2: 1374.58
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1940.51,1068.55l176.14,101.7c7.95,4.59,17.89-1.15,17.89-10.33v-203.39c0-9.18-9.94-14.92-17.89-10.33l-176.14,101.7c-7.95,4.59-7.95,16.07,0,20.66Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "2000.29 2288.28 1818.09 2362.63 1635.51 2288.28 1818.09 2220.9 2000.29 2288.28"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1635.51,
    y1: 2288.28,
    x2: 1635.51,
    y2: 2011.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1636.21,
    y1: 2010.97,
    x2: 1818.78,
    y2: 1943.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1818.84,
    y1: 2221.66,
    x2: 1818.84,
    y2: 1944.91
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1773.09,2090.72l135.37,78.16c7.95,4.59,17.89-1.15,17.89-10.33v-156.32c0-9.18-9.94-14.92-17.89-10.33l-135.37,78.16c-7.95,4.59-7.95,16.07,0,20.66Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "2000.29 2779.28 1818.09 2853.63 1635.51 2779.28 1818.09 2711.9 2000.29 2779.28"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1635.51,
    y1: 2779.28,
    x2: 1635.51,
    y2: 2502.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1636.21,
    y1: 2501.97,
    x2: 1818.78,
    y2: 2434.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1818.84,
    y1: 2712.66,
    x2: 1818.84,
    y2: 2435.91
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1704.52,2596.06l-135.37-78.16c-7.95-4.59-17.89,1.15-17.89,10.33v156.32c0,9.18,9.94,14.92,17.89,10.33l135.37-78.16c7.95-4.59,7.95-16.07,0-20.66Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 158.39,
    y1: 451.88,
    x2: 158.39,
    y2: 105.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 283.32,
    y1: 279.98,
    x2: 283.32,
    y2: 243.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 159.08,
    y1: 104.77,
    x2: 341.55,
    y2: 37.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 250.03,
    y1: 254.69,
    x2: 283.18,
    y2: 242.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 159.08,
    y1: 462.56,
    x2: 341.55,
    y2: 395.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 341.61,
    y1: 385.3,
    x2: 341.61,
    y2: 38.75
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_10"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M384.58,54.75c.45.05.9.11,1.35.17-.45-.06-.9-.12-1.35-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M318.71,68.25c2.17-1.26,4.39-2.45,6.65-3.56-2.26,1.11-4.48,2.3-6.65,3.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M373.66,127.84c1.3.13,2.56.39,3.77.77-1.21-.38-2.47-.64-3.77-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M387.25,55.11c.44.07.89.14,1.33.21-.44-.07-.89-.14-1.33-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M389.9,55.54c.44.08.88.16,1.32.24-.44-.08-.88-.16-1.32-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M379.2,129.25c1.16.49,2.25,1.09,3.28,1.78-1.03-.69-2.12-1.29-3.28-1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M390.99,224.28h0c0,2-.3,3.93-.87,5.74.56-1.81.87-3.74.87-5.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M353.46,263.91c-.44-.08-.87-.16-1.3-.24.43.08.87.16,1.3.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M356.11,264.34c-.44-.07-.88-.13-1.32-.2.44.07.88.14,1.32.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M390.12,141.3c.38,1.21.64,2.47.77,3.77-.13-1.3-.39-2.56-.77-3.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M409.38,258.52c-.43.17-.87.33-1.3.49.43-.16.87-.32,1.3-.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M387.69,136.25c.69,1.03,1.29,2.12,1.78,3.28-.49-1.16-1.09-2.25-1.78-3.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M350.83,263.42c-.43-.09-.86-.18-1.29-.27.43.09.86.18,1.29.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M477.37,155.69c.02.61.03,1.23.05,1.85-.01-.62-.02-1.23-.05-1.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M477.24,152.96c.03.54.06,1.09.08,1.63-.03-.54-.05-1.09-.08-1.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M424.66,251.2c-.98.57-1.97,1.12-2.96,1.65,1-.54,1.98-1.09,2.96-1.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M476.75,147.55c.05.47.1.95.15,1.42-.05-.47-.09-.95-.15-1.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M470.74,196.76c-1.79,4.76-3.91,9.35-6.34,13.76,2.43-4.41,4.55-9,6.34-13.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M477.03,150.24c.04.5.08,1,.12,1.5-.04-.5-.07-1-.12-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M464.4,210.51c-1.21,2.2-2.5,4.36-3.87,6.46,1.36-2.1,2.65-4.26,3.87-6.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M439.01,241.17c-1.55,1.29-3.15,2.53-4.78,3.73,1.63-1.2,3.22-2.44,4.78-3.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M451.51,228.96c-1.09,1.26-2.21,2.49-3.36,3.69,1.15-1.2,2.27-2.44,3.36-3.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M454.7,225.11c-1.03,1.31-2.1,2.59-3.19,3.85,1.09-1.26,2.16-2.54,3.19-3.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M459.14,219.06c-.94,1.38-1.91,2.74-2.92,4.07,1-1.33,1.98-2.69,2.92-4.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M339.46,59c1.62-.52,3.26-1,4.91-1.45-1.65.44-3.29.93-4.91,1.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M310.36,245.84c-.3-.21-.6-.43-.89-.65.3.22.59.43.89.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M379.18,54.23c.46.03.92.07,1.38.11-.46-.04-.92-.07-1.38-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M312.48,247.32c-.31-.21-.61-.42-.92-.63.31.21.61.43.92.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M308.28,244.32c-.29-.22-.58-.44-.87-.66.29.22.58.44.87.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M316.82,250.11c-.32-.2-.64-.39-.96-.59.32.2.64.4.96.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M314.63,248.74c-.31-.2-.63-.41-.94-.61.31.21.62.41.94.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M476.41,144.87c.06.45.12.91.18,1.37-.06-.46-.11-.91-.18-1.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M332.29,61.6c2.35-.95,4.74-1.82,7.17-2.6-2.43.78-4.82,1.65-7.17,2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M327.64,63.6c1.53-.71,3.08-1.38,4.65-2.01-1.57.63-3.12,1.3-4.65,2.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M319.05,251.43c-.33-.19-.66-.38-.99-.58.33.19.66.39.99.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M373.69,53.99c.47,0,.94.02,1.4.04-.47-.01-.93-.03-1.4-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M376.44,54.07c.46.02.93.04,1.39.07-.46-.03-.92-.05-1.39-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M340.54,260.81c-.4-.12-.8-.25-1.2-.38.4.13.8.26,1.2.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M338.04,260c-.39-.13-.79-.27-1.18-.41.39.14.79.27,1.18.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M348.22,262.86c-.42-.1-.84-.2-1.26-.3.42.1.84.2,1.26.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M345.64,262.24c-.42-.11-.83-.22-1.25-.33.41.11.83.22,1.25.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M335.56,259.13c-.39-.14-.77-.28-1.15-.43.38.15.77.29,1.15.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M343.08,261.55c-.41-.12-.82-.23-1.23-.35.41.12.82.24,1.23.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M321.31,252.7c-.34-.18-.67-.37-1.01-.56.34.19.67.38,1.01.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M333.1,258.2c-.38-.15-.75-.3-1.13-.45.37.15.75.3,1.13.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M323.61,253.91c-.35-.18-.69-.36-1.03-.54.34.18.69.36,1.03.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M325.93,255.07c-.35-.17-.71-.35-1.06-.52.35.17.71.35,1.06.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M328.29,256.17c-.36-.16-.72-.33-1.08-.5.36.17.72.34,1.08.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M330.69,257.21c-.37-.16-.74-.32-1.11-.48.37.16.74.32,1.11.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M381.89,54.46c.46.04.91.09,1.36.14-.45-.05-.91-.1-1.36-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M430.89,72.14c.3.21.61.42.91.63-.3-.21-.6-.42-.91-.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M433.01,73.61c.3.21.59.43.89.65-.3-.22-.59-.43-.89-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M435.09,75.14c.29.22.58.44.86.66-.29-.22-.57-.44-.86-.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M428.74,70.72c.31.2.62.41.93.61-.31-.2-.62-.41-.93-.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M424.32,68.02c.33.19.66.38.98.58-.33-.19-.65-.39-.98-.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M426.54,69.34c.32.2.64.4.96.59-.32-.2-.64-.4-.96-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M437.13,76.71c.28.22.56.45.84.67-.28-.23-.56-.45-.84-.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M444.88,83.47c.25.24.5.49.75.74-.25-.25-.5-.49-.75-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M443.01,81.71c.26.24.52.48.78.72-.26-.24-.52-.48-.78-.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M439.13,78.33c.27.23.54.46.82.69-.27-.23-.54-.46-.82-.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M476,142.22c.07.44.14.89.21,1.33-.07-.44-.13-.89-.21-1.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M441.09,80c.27.23.53.47.8.71-.27-.24-.53-.47-.8-.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M415.07,63.29c.36.16.72.33,1.08.5-.36-.17-.72-.33-1.08-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M400.29,57.9c.41.12.82.23,1.22.35-.41-.12-.82-.24-1.22-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M402.82,58.65c.4.12.8.25,1.21.38-.4-.13-.8-.26-1.21-.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M397.73,57.21c.42.11.83.22,1.25.33-.42-.11-.83-.22-1.25-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M405.33,59.45c.4.13.79.27,1.18.41-.39-.14-.79-.27-1.18-.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M395.15,56.59c.42.1.85.2,1.27.3-.42-.1-.84-.2-1.27-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M417.43,64.39c.35.17.71.34,1.06.52-.35-.17-.7-.35-1.06-.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M407.81,60.32c.39.14.77.29,1.16.43-.38-.15-.77-.29-1.16-.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M446.72,85.27c.25.25.49.5.73.75-.24-.25-.49-.5-.73-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M419.76,65.55c.35.18.69.36,1.03.54-.34-.18-.69-.36-1.03-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M412.68,62.24c.37.16.74.32,1.11.48-.37-.16-.74-.32-1.11-.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M410.26,61.25c.38.15.76.3,1.13.45-.38-.15-.75-.31-1.13-.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M422.06,66.76c.34.18.67.37,1.01.56-.33-.19-.67-.37-1.01-.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M470.44,121.86c.14.35.27.71.4,1.07-.13-.36-.26-.71-.4-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M469.47,119.44c.14.35.28.7.42,1.05-.14-.35-.28-.7-.42-1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M472.2,126.8c.12.37.24.74.35,1.12-.12-.37-.23-.75-.35-1.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M471.35,124.31c.13.36.25.73.38,1.09-.13-.36-.25-.73-.38-1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M468.44,117.04c.15.34.29.68.44,1.02-.15-.34-.29-.68-.44-1.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M467.36,114.68c.15.33.3.66.45.99-.15-.33-.3-.66-.45-.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M448.5,87.12c.24.25.48.51.72.77-.24-.26-.48-.52-.72-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M472.99,129.3c.11.38.22.77.33,1.15-.11-.38-.22-.77-.33-1.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M474.98,136.98c.09.42.17.84.26,1.25-.09-.42-.17-.84-.26-1.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M475.52,139.59c.08.43.16.86.24,1.3-.08-.43-.15-.87-.24-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M474.38,134.4c.1.4.19.81.28,1.21-.09-.4-.19-.81-.28-1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M466.22,112.35c.16.32.32.64.47.97-.16-.32-.31-.65-.47-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M473.71,131.84c.11.39.21.78.31,1.18-.1-.39-.2-.79-.31-1.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M455.2,94.92c.21.27.42.55.63.82-.21-.27-.42-.55-.63-.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M465.03,110.05c.17.32.33.64.5.96-.17-.32-.33-.64-.5-.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M453.6,92.91c.22.27.43.54.65.81-.22-.27-.43-.54-.65-.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M450.25,89.01c.23.26.46.52.7.79-.23-.26-.46-.53-.7-.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M451.95,90.94c.23.26.45.53.67.8-.22-.27-.45-.53-.67-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M456.76,96.97c.21.28.41.56.61.84-.2-.28-.41-.56-.61-.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M462.48,105.55c.18.3.36.61.54.92-.18-.31-.36-.61-.54-.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M458.26,99.06c.2.28.4.57.59.86-.2-.29-.39-.58-.59-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M463.78,107.78c.18.31.35.63.52.94-.17-.31-.34-.63-.52-.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M461.13,103.35c.19.3.37.6.55.89-.18-.3-.37-.6-.55-.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M459.72,101.19c.19.29.38.58.57.88-.19-.29-.38-.59-.57-.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M377.43,113.61c-1.21.38-2.47.64-3.77.77,1.3-.13,2.56-.39,3.77-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M276.01,204.77c-.16-.33-.31-.67-.46-1,.15.33.3.67.46,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M298.75,83.27c-1.2,1.15-2.38,2.33-3.53,3.53,1.15-1.2,2.33-2.38,3.53-3.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M372.34,53.97c-.22,0-.44,0-.66,0-.5,0-.99,0-1.48.01-8.91.12-17.57,1.36-25.83,3.58,8.26-2.22,16.92-3.46,25.83-3.58.72,0,1.43,0,2.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M273.55,120.33c.63-1.57,1.3-3.12,2.01-4.65-.71,1.53-1.38,3.08-2.01,4.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M470.74,196.76c4.17-11.1,6.53-23.07,6.7-35.54.01-.93.01-1.85,0-2.77.01.92.01,1.84,0,2.77-.17,12.48-2.53,24.45-6.7,35.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M274.92,202.41c-.15-.34-.29-.68-.44-1.02.15.34.29.68.44,1.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M373.66,75.96c1.3.13,2.56.39,3.77.77-1.21-.38-2.47-.64-3.77-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M278.34,209.41c-.17-.32-.33-.64-.5-.96.17.32.33.64.5.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M390.99,95.17h0c0,2-.3,3.93-.87,5.74.56-1.81.87-3.74.87-5.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M388.66,104.37c-.59,1.09-1.29,2.12-2.08,3.08.79-.95,1.48-1.98,2.08-3.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M387.69,84.37c.69,1.03,1.29,2.12,1.78,3.28-.49-1.16-1.09-2.25-1.78-3.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M390.12,89.43c.38,1.21.64,2.47.77,3.77-.13-1.3-.39-2.56-.77-3.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M277.14,207.11c-.16-.32-.32-.65-.48-.98.16.33.32.65.48.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M382.48,111.18c-1.03.69-2.12,1.29-3.28,1.78,1.16-.49,2.25-1.09,3.28-1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M379.2,77.38c1.16.49,2.25,1.09,3.28,1.78-1.03-.69-2.12-1.29-3.28-1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M270.38,190.15c-.12-.39-.23-.78-.34-1.18.11.39.22.79.34,1.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M269.65,187.62c-.11-.4-.21-.8-.31-1.2.1.4.21.8.31,1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M271.17,192.66c-.12-.38-.24-.76-.36-1.14.12.38.24.76.36,1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M388.77,233.26c.25-.48.49-.96.7-1.46-.21.5-.45.98-.7,1.46h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M305.96,242.53c.09.07.18.14.28.21-.09-.07-.18-.15-.27-.22h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M268.99,185.06c-.1-.4-.19-.81-.29-1.22.1.41.19.81.29,1.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M267.37,177.23c-.07-.44-.14-.89-.21-1.34.07.45.13.89.21,1.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M268.38,182.47c-.09-.41-.17-.83-.26-1.24.09.41.17.83.26,1.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M266.27,168.3h0c.02.3.04.61.07.91-.03-.3-.05-.61-.07-.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M272.93,197.59c-.14-.36-.27-.71-.4-1.07.13.36.26.72.4,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M272.02,195.14c-.13-.36-.25-.73-.38-1.1.13.37.25.73.38,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M282.02,103.78c1.61-2.56,3.31-5.05,5.12-7.46-1.81,2.41-3.52,4.9-5.12,7.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M273.9,200.02c-.14-.35-.28-.7-.42-1.05.14.35.28.7.42,1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M272.63,122.7c-1.46,3.89-2.7,7.89-3.7,11.97h0c1-4.09,2.24-8.09,3.7-11.97Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "52.35 381.4 189.14 437.1 189.14 277.07 52.35 222.11 52.35 381.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M267.84,179.86c-.08-.43-.16-.86-.23-1.28.08.43.15.86.23,1.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M282.24,216.1c-.19-.3-.37-.6-.56-.9.19.3.37.6.56.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M298.75,83.27c1.2-1.15,2.44-2.27,3.69-3.36-1.26,1.09-2.49,2.21-3.69,3.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M291.86,90.49c1.09-1.26,2.21-2.49,3.36-3.69-1.15,1.2-2.27,2.44-3.36,3.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M266.96,174.58c-.07-.46-.12-.93-.18-1.4.06.47.11.93.18,1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M392.54,56.03c.43.09.86.18,1.29.27-.43-.09-.86-.18-1.29-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M279.58,211.67c-.17-.31-.34-.62-.52-.93.17.31.34.62.52.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M280.89,213.91c-.18-.3-.36-.61-.53-.91.18.3.35.61.53.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M304.35,78.28c3.21-2.66,6.57-5.13,10.08-7.4-3.51,2.27-6.87,4.74-10.08,7.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M266.61,171.91c-.06-.49-.1-.97-.15-1.46.05.49.09.98.15,1.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M265.99,163.77c-.03-.67-.04-1.35-.05-2.03.01.68.03,1.36.05,2.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M266.13,166.5c-.04-.58-.06-1.17-.09-1.75.03.58.05,1.17.09,1.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M289.77,226.54c-.22-.27-.43-.54-.65-.81.22.27.43.54.65.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M296.65,234.18c-.25-.25-.49-.5-.74-.76.25.25.49.51.74.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M386.58,236.57c.84-1.02,1.57-2.13,2.19-3.31h0c-.62,1.18-1.35,2.29-2.19,3.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M285.1,220.4c-.2-.29-.4-.58-.6-.87.2.29.4.58.6.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M361.48,265c-.45-.04-.9-.09-1.35-.14.45.05.9.1,1.35.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M371.68,243.59c-3.75,0-7.23-1.08-10.19-2.93,2.96,1.85,6.45,2.93,10.19,2.93h0c4,0,7.71-1.22,10.8-3.3-3.08,2.08-6.8,3.3-10.8,3.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M357.44,237.28c.42.46.85.89,1.31,1.31-.46-.41-.9-.85-1.31-1.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M383.97,239.18c.95-.79,1.83-1.66,2.62-2.62-.79.95-1.66,1.83-2.62,2.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M286.61,222.48c-.21-.28-.41-.57-.62-.85.21.28.41.57.62.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M291.42,228.52c-.23-.26-.45-.53-.67-.8.22.27.45.54.67.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M293.12,230.45c-.23-.26-.46-.52-.7-.79.23.26.46.53.7.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M294.86,232.33c-.24-.25-.48-.51-.72-.77.24.26.47.51.72.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.68,297.84c-5.13,0-10.22-.29-15.26-.84v84.7l-134.94,55.06v-160.04l51.24-20.74c-7.89-8.11-14.68-17.03-20.32-26.67l-45.98,18.61c-.37-.03-.74-.06-1.12-.06-.62,0-1.23.04-1.83.11l-130.79-52.54,134.69-49.7,26.25,10.06c.32-11.2,1.97-22.19,4.89-32.77l-25.04-9.6c-3.84-1.47-7.89-1.37-11.46-.03-.69.16-1.38.34-2.06.59L31.22,176.26c-1.84.68-3.46,1.67-4.87,2.87-3.85,2.96-6.34,7.59-6.34,12.82v6.47s0,.05,0,.08v193.78s0,.04,0,.05c0,.44.03.87.07,1.3,0,.11,0,.23.02.34.04.35.1.69.16,1.04.03.19.05.38.09.57.03.12.06.24.09.36.41,1.77,1.11,3.42,2.04,4.91.09.15.18.31.28.46.08.11.16.21.24.32,1.07,1.51,2.39,2.84,3.96,3.93.06.04.12.09.19.14.18.12.37.22.55.34.28.17.55.35.84.5.11.06.23.11.35.17.37.19.75.37,1.14.53.02,0,.04.02.05.03l168.74,68.72c1.96.8,4.03,1.19,6.1,1.19s4.15-.4,6.11-1.2l168.39-68.72c7.81-3.19,11.78-11.79,9.35-19.7v-90.77c-5,.62-10.06.98-15.16,1.05-.65,0-1.29.01-1.93.01ZM189.14,437.1l-136.79-55.7v-159.28l136.79,54.95v160.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M371.68,265.49c.49,0,.98,0,1.47-.01-.71,0-1.42,0-2.13,0,.22,0,.43,0,.65,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M364.18,265.22c-.46-.03-.91-.07-1.36-.1.45.04.91.07,1.36.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M369.66,265.47c-.46,0-.92-.02-1.39-.03.46.01.92.03,1.39.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M304.24,241.12c-.28-.23-.55-.46-.83-.7.27.23.55.47.83.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M265.92,161.01c-.01-.92-.01-1.84,0-2.77.11-8.1,1.15-15.99,3-23.57h0c-1.85,7.58-2.89,15.47-3,23.57-.01.93-.01,1.85,0,2.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M358.78,264.7c-.45-.05-.89-.11-1.33-.17.44.06.89.12,1.33.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M283.65,218.27c-.2-.29-.39-.59-.58-.88.19.29.38.59.58.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M300.36,237.74c-.26-.24-.52-.48-.78-.72.26.24.52.48.78.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M266.22,167.63c.02.22.03.45.05.67h0c-.02-.22-.03-.45-.05-.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M305.39,242.06c.19.15.38.31.57.47h0c-.19-.16-.38-.31-.58-.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M298.48,235.98c-.25-.24-.51-.49-.76-.74.25.25.5.49.76.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M366.91,265.38c-.46-.02-.91-.04-1.37-.07.46.03.91.05,1.37.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M288.16,224.53c-.21-.28-.42-.55-.64-.83.21.28.42.56.64.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M302.28,239.46c-.27-.23-.53-.47-.8-.71.27.24.53.47.8.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.42,157.54c-.01-.62-.02-1.23-.05-1.85-.01-.37-.04-.74-.06-1.1-.03-.54-.05-1.09-.08-1.63-.03-.41-.06-.81-.09-1.22-.04-.5-.07-1-.12-1.5-.04-.43-.09-.85-.13-1.27-.05-.47-.09-.95-.15-1.42-.05-.44-.11-.87-.17-1.31-.06-.46-.11-.91-.18-1.37-.06-.44-.13-.88-.2-1.32-.07-.44-.13-.89-.21-1.33-.07-.45-.16-.89-.24-1.33-.08-.43-.15-.87-.24-1.3-.09-.45-.19-.9-.28-1.36-.09-.42-.17-.84-.26-1.25-.1-.46-.21-.91-.32-1.37-.09-.4-.19-.81-.28-1.21-.11-.46-.24-.92-.36-1.38-.1-.39-.2-.79-.31-1.18-.13-.46-.26-.92-.4-1.38-.11-.38-.22-.77-.33-1.15-.14-.47-.29-.93-.44-1.39-.12-.37-.23-.75-.35-1.12-.15-.47-.32-.93-.47-1.39-.13-.36-.25-.73-.38-1.09-.17-.46-.34-.92-.51-1.38-.13-.36-.26-.71-.4-1.07-.18-.46-.36-.92-.55-1.38-.14-.35-.28-.7-.42-1.05-.19-.46-.39-.92-.59-1.38-.15-.34-.29-.68-.44-1.02-.2-.46-.42-.92-.63-1.38-.15-.33-.3-.66-.45-.99-.22-.46-.44-.91-.66-1.37-.16-.32-.31-.65-.47-.97-.23-.45-.46-.9-.7-1.35-.17-.32-.33-.64-.5-.96-.24-.45-.48-.89-.73-1.33-.17-.31-.34-.63-.52-.94-.25-.44-.51-.88-.76-1.31-.18-.31-.36-.62-.54-.92-.26-.44-.53-.87-.8-1.3-.18-.3-.37-.6-.55-.89-.27-.43-.55-.86-.83-1.29-.19-.29-.38-.59-.57-.88-.28-.43-.57-.85-.86-1.27-.2-.29-.39-.58-.59-.86-.29-.42-.59-.83-.89-1.24-.2-.28-.41-.56-.61-.84-.31-.41-.62-.82-.93-1.23-.21-.27-.42-.55-.63-.82-.31-.4-.63-.8-.95-1.2-.22-.27-.43-.54-.65-.81-.32-.39-.65-.78-.98-1.17-.22-.27-.45-.53-.67-.8-.33-.39-.67-.77-1-1.15-.23-.26-.46-.53-.7-.79-.34-.38-.68-.75-1.03-1.12-.24-.26-.48-.52-.72-.77-.35-.37-.7-.73-1.05-1.09-.24-.25-.49-.5-.73-.75-.36-.36-.72-.71-1.08-1.07-.25-.25-.5-.49-.75-.74-.36-.35-.73-.69-1.1-1.04-.26-.24-.52-.48-.78-.72-.37-.34-.74-.67-1.12-1.01-.27-.24-.53-.47-.8-.71-.38-.33-.76-.65-1.14-.98-.27-.23-.54-.46-.82-.69-.38-.32-.77-.63-1.16-.95-.28-.23-.56-.45-.84-.67-.39-.31-.78-.61-1.18-.91-.29-.22-.57-.44-.86-.66-.39-.3-.79-.59-1.19-.88-.3-.22-.59-.43-.89-.65-.4-.29-.8-.57-1.21-.85-.3-.21-.6-.42-.91-.63-.41-.28-.81-.55-1.22-.82-.31-.2-.62-.41-.93-.61-.41-.26-.82-.52-1.23-.78-.32-.2-.64-.4-.96-.59-.41-.25-.83-.5-1.24-.74-.33-.19-.65-.39-.98-.58-.42-.24-.84-.48-1.26-.71-.33-.19-.67-.37-1.01-.56-.42-.23-.84-.45-1.27-.68-.34-.18-.69-.36-1.03-.54-.42-.22-.85-.43-1.27-.64-.35-.17-.7-.35-1.06-.52-.42-.2-.85-.4-1.28-.6-.36-.17-.72-.33-1.08-.5-.43-.19-.86-.38-1.28-.57-.37-.16-.74-.32-1.11-.48-.43-.18-.86-.36-1.29-.53-.38-.15-.75-.31-1.13-.45-.43-.17-.86-.33-1.3-.5-.38-.15-.77-.29-1.16-.43-.43-.16-.86-.31-1.3-.46-.39-.14-.79-.27-1.18-.41-.43-.15-.87-.29-1.3-.43-.4-.13-.8-.26-1.21-.38-.43-.13-.87-.26-1.31-.39-.41-.12-.82-.24-1.22-.35-.44-.12-.87-.24-1.31-.36-.42-.11-.83-.22-1.25-.33-.44-.11-.88-.22-1.31-.32-.42-.1-.84-.2-1.27-.3-.44-.1-.88-.2-1.32-.29-.43-.09-.86-.18-1.29-.27-.44-.09-.88-.17-1.32-.26-.44-.08-.88-.16-1.32-.24-.44-.08-.88-.15-1.32-.22-.44-.07-.89-.14-1.33-.21-.44-.07-.88-.13-1.33-.19-.45-.06-.9-.12-1.35-.17-.44-.05-.89-.11-1.33-.15-.45-.05-.91-.1-1.36-.14-.44-.04-.89-.08-1.34-.12-.46-.04-.92-.07-1.38-.11-.45-.03-.9-.06-1.34-.09-.46-.03-.92-.05-1.39-.07-.45-.02-.9-.04-1.35-.05-.47-.01-.93-.03-1.4-.04-.45,0-.9-.01-1.35-.02-.71,0-1.43,0-2.14,0-8.91.12-17.57,1.36-25.83,3.58-1.65.44-3.29.93-4.91,1.45-2.43.78-4.82,1.65-7.17,2.6-1.57.63-3.12,1.3-4.65,2.01-.76.35-1.52.71-2.28,1.08-2.26,1.11-4.48,2.3-6.65,3.56-1.45.84-2.87,1.72-4.28,2.63-3.51,2.27-6.87,4.74-10.08,7.4-.64.53-1.28,1.07-1.91,1.62-1.26,1.09-2.49,2.21-3.69,3.36-1.2,1.15-2.38,2.33-3.53,3.53-1.15,1.2-2.27,2.44-3.36,3.69-1.09,1.26-2.16,2.54-3.19,3.85-.52.65-1.03,1.31-1.53,1.98-1.81,2.41-3.52,4.9-5.12,7.46-1.06,1.69-2.08,3.41-3.05,5.16-1.21,2.2-2.35,4.45-3.41,6.75-.71,1.53-1.38,3.08-2.01,4.65-.32.78-.62,1.57-.92,2.36-1.46,3.89-2.7,7.89-3.7,11.97-1.85,7.58-2.89,15.47-3,23.57-.01.93-.01,1.85,0,2.77,0,.24.01.48.02.72.01.68.03,1.36.05,2.03.01.33.03.66.05.98.03.58.05,1.17.09,1.75.02.38.06.75.09,1.13.02.22.03.45.05.67.02.3.04.61.07.91.04.41.08.82.13,1.23.05.49.09.98.15,1.46.05.43.11.85.16,1.28.06.47.11.93.18,1.4.06.44.13.87.2,1.31.07.45.13.89.21,1.34.08.45.16.9.24,1.35.08.43.15.86.23,1.28.09.46.19.91.28,1.37.09.41.17.83.26,1.24.1.46.21.91.32,1.37.1.41.19.81.29,1.22.11.45.23.91.35,1.36.1.4.21.8.31,1.2.12.46.26.91.39,1.36.11.39.22.79.34,1.18.14.46.28.91.43,1.37.12.38.24.76.36,1.14.15.46.31.92.47,1.38.13.37.25.73.38,1.1.17.46.34.92.51,1.38.13.36.26.72.4,1.07.18.46.36.92.55,1.38.14.35.28.7.42,1.05.19.46.39.92.59,1.37.15.34.29.68.44,1.02.2.46.41.91.62,1.37.15.33.3.67.46,1,.21.45.44.9.66,1.36.16.33.32.65.48.98.23.45.46.9.69,1.34.17.32.33.64.5.96.24.45.49.89.73,1.33.17.31.34.62.52.93.25.44.51.88.77,1.32.18.3.35.61.53.91.26.44.53.87.8,1.3.19.3.37.6.56.9.19.3.39.6.58.89.08.13.17.26.25.39.19.29.38.59.58.88.28.42.57.84.86,1.26.2.29.4.58.6.87.29.41.59.82.89,1.24.21.28.41.57.62.85.3.41.61.81.92,1.22.21.28.42.56.64.83.31.4.63.8.95,1.2.22.27.43.54.65.81.32.39.65.78.98,1.17.22.27.45.54.67.8.33.38.67.76,1,1.14.23.26.46.53.7.79.34.38.68.75,1.03,1.12.24.26.47.51.72.77.35.37.7.73,1.05,1.09.25.25.49.51.74.76.35.36.71.71,1.07,1.06.25.25.5.49.76.74.36.35.73.69,1.1,1.04.26.24.52.48.78.72.37.34.74.67,1.12,1.01.27.24.53.47.8.71.38.33.76.65,1.14.97.27.23.55.47.83.7.38.32.77.63,1.15.94.19.15.38.31.58.46.09.07.18.15.27.22.39.31.78.61,1.17.91.29.22.58.44.87.66.39.3.79.59,1.19.88.3.22.59.43.89.65.4.28.8.56,1.2.84.31.21.61.43.92.63.4.27.81.54,1.21.81.31.21.62.41.94.61.41.26.82.52,1.23.78.32.2.64.4.96.59.41.25.83.5,1.24.74.33.19.66.39.99.58.41.24.83.47,1.25.71.34.19.67.38,1.01.56.42.23.84.45,1.26.67.34.18.69.36,1.03.54.42.22.84.43,1.27.64.35.17.71.35,1.06.52.42.2.85.4,1.28.6.36.17.72.34,1.08.5.43.19.85.38,1.28.57.37.16.74.32,1.11.48.43.18.86.36,1.29.53.37.15.75.3,1.13.45.43.17.87.34,1.3.5.38.14.77.29,1.15.43.43.16.87.31,1.3.46.39.14.79.27,1.18.41.43.15.87.29,1.3.43.4.13.8.26,1.2.38.44.13.87.27,1.31.39.41.12.82.24,1.23.35.44.12.87.24,1.31.36.41.11.83.22,1.25.33.44.11.88.22,1.32.33.42.1.84.2,1.26.3.44.1.88.2,1.32.29.43.09.86.18,1.29.27.44.09.88.17,1.33.26.43.08.87.16,1.3.24.44.08.89.15,1.33.22.44.07.88.14,1.32.2.11.02.21.03.32.05.34.05.68.1,1.02.14.44.06.89.12,1.33.17.45.05.89.11,1.34.16.45.05.9.1,1.35.14.45.04.9.08,1.34.12.45.04.91.07,1.36.1.45.03.9.06,1.36.09.46.03.91.05,1.37.07.45.02.91.04,1.36.05.46.01.92.03,1.39.03.46,0,.91.01,1.37.02.71,0,1.42,0,2.13,0h0c5.3-.07,10.51-.54,15.61-1.38,6.66-1.09,13.12-2.81,19.3-5.1.43-.16.87-.32,1.3-.49,2.15-.83,4.27-1.71,6.35-2.67.76-.35,1.52-.71,2.28-1.08,1.25-.61,2.48-1.25,3.69-1.91,1-.54,1.98-1.09,2.96-1.65.72-.42,1.44-.85,2.15-1.29,2.55-1.57,5.02-3.24,7.42-5.01,1.63-1.2,3.22-2.44,4.78-3.73.64-.53,1.28-1.07,1.91-1.62,1.26-1.09,2.49-2.21,3.69-3.36,1.2-1.15,2.38-2.33,3.53-3.53,1.15-1.2,2.27-2.44,3.36-3.69,1.09-1.26,2.16-2.54,3.19-3.85.52-.65,1.03-1.31,1.53-1.98,1-1.33,1.98-2.69,2.92-4.07.47-.69.93-1.39,1.39-2.09,1.36-2.1,2.65-4.26,3.87-6.46,2.43-4.41,4.55-9,6.34-13.76,4.17-11.1,6.53-23.07,6.7-35.54.01-.93.01-1.85,0-2.77,0-.3-.02-.6-.02-.91ZM390.99,224.28h0c0,2-.3,3.93-.87,5.74-.19.6-.41,1.2-.65,1.77-.21.5-.45.98-.7,1.46-.62,1.18-1.35,2.29-2.19,3.31-.79.95-1.66,1.83-2.62,2.62-.48.39-.97.76-1.49,1.11-3.08,2.08-6.8,3.3-10.8,3.3h0c-3.75,0-7.23-1.08-10.19-2.93-.98-.61-1.89-1.3-2.74-2.07-.46-.41-.9-.85-1.31-1.31-.35-.39-.69-.78-1.01-1.2-2.53-3.27-4.05-7.35-4.05-11.8v-77.24c0-5.33,2.16-10.16,5.66-13.65,1.31-1.31,2.81-2.43,4.45-3.32,2.74-1.49,5.87-2.33,9.2-2.33h0c.67,0,1.32.03,1.97.1,1.3.13,2.56.39,3.77.77.6.19,1.2.41,1.77.65,1.16.49,2.25,1.09,3.28,1.78,2.05,1.39,3.83,3.16,5.22,5.22.69,1.03,1.29,2.12,1.78,3.28.24.58.46,1.17.65,1.77.38,1.21.64,2.47.77,3.77.07.65.1,1.31.1,1.97v77.24ZM390.12,100.91c-.38,1.21-.87,2.37-1.46,3.46-.59,1.09-1.29,2.12-2.08,3.08-1.18,1.43-2.56,2.69-4.1,3.73-1.03.69-2.12,1.29-3.28,1.78-.58.24-1.17.46-1.77.65-1.21.38-2.47.64-3.77.77-.65.07-1.31.1-1.97.1h0c-3.33,0-6.47-.84-9.2-2.33-1.64-.89-3.14-2.01-4.45-3.33-3.49-3.49-5.66-8.32-5.66-13.65s2.16-10.16,5.66-13.65c1.31-1.31,2.81-2.43,4.45-3.33,2.74-1.49,5.87-2.33,9.2-2.33h0c.67,0,1.32.03,1.97.1,1.3.13,2.56.39,3.77.77.6.19,1.2.41,1.77.65,1.16.49,2.25,1.09,3.28,1.78,2.05,1.39,3.83,3.16,5.22,5.22.69,1.03,1.29,2.12,1.78,3.28.24.58.46,1.17.65,1.77.38,1.21.64,2.47.77,3.77.07.65.1,1.31.1,1.97,0,2-.3,3.93-.87,5.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M437.97,77.39c.39.31.78.63,1.16.95-.38-.32-.77-.63-1.16-.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M276.66,206.13c-.22-.45-.44-.9-.66-1.36.21.45.44.9.66,1.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M327.21,255.67c-.43-.2-.85-.4-1.28-.6.42.2.85.4,1.28.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M358.03,81.52c1.31-1.31,2.81-2.43,4.45-3.33-1.64.89-3.14,2.01-4.45,3.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M439.95,79.02c.38.32.76.65,1.14.98-.38-.33-.76-.65-1.14-.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M441.89,80.71c.37.33.75.67,1.12,1.01-.37-.34-.74-.67-1.12-1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M435.95,75.8c.39.3.79.6,1.18.91-.39-.31-.78-.61-1.18-.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M320.3,252.14c-.42-.23-.84-.47-1.25-.71.41.24.83.47,1.25.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M322.57,253.37c-.42-.22-.84-.45-1.26-.67.42.23.84.45,1.26.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M324.87,254.55c-.42-.21-.85-.42-1.27-.64.42.22.84.43,1.27.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M429.67,71.33c.41.27.82.54,1.22.82-.41-.28-.81-.55-1.22-.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M455.83,95.74c.31.41.62.82.93,1.23-.31-.41-.62-.82-.93-1.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M329.58,256.74c-.43-.19-.86-.38-1.28-.57.43.19.85.38,1.28.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M277.84,208.45c-.23-.45-.47-.89-.69-1.34.23.45.46.9.69,1.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M433.9,74.26c.4.29.8.58,1.19.88-.39-.3-.79-.59-1.19-.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M336.86,259.59c-.43-.15-.87-.31-1.3-.46.43.16.87.31,1.3.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M452.62,91.74c.33.39.66.78.98,1.17-.32-.39-.65-.78-.98-1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M450.94,89.79c.34.38.67.76,1,1.15-.33-.39-.67-.77-1-1.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M356.11,264.34c.11.02.21.03.32.05h0c-.11-.02-.21-.03-.32-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M334.4,258.7c-.43-.16-.87-.33-1.3-.5.43.17.87.34,1.3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M443.78,82.43c.37.34.74.69,1.1,1.04-.36-.35-.73-.69-1.1-1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M454.25,93.72c.32.4.64.8.95,1.2-.31-.4-.63-.8-.95-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M278.97,108.94c.97-1.75,1.99-3.47,3.05-5.16-1.06,1.69-2.08,3.41-3.05,5.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M275.55,203.78c-.21-.45-.42-.91-.62-1.37.2.46.41.91.62,1.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M445.64,84.21c.36.35.72.71,1.08,1.07-.36-.36-.72-.71-1.08-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M331.98,257.75c-.43-.18-.86-.35-1.29-.53.43.18.86.36,1.29.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M449.22,87.89c.34.37.69.74,1.03,1.12-.34-.38-.68-.75-1.03-1.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M447.45,86.03c.35.36.71.73,1.05,1.09-.35-.37-.7-.73-1.05-1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M388.77,264.11c6.66-1.09,13.12-2.81,19.3-5.1-6.19,2.28-12.64,4.01-19.3,5.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M431.8,72.77c.4.28.81.56,1.21.85-.4-.29-.8-.57-1.21-.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M309.47,245.19c-.4-.29-.79-.58-1.19-.88.39.3.79.59,1.19.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M404.03,59.03c.43.14.87.28,1.3.43-.43-.15-.87-.29-1.3-.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M307.41,243.65c-.39-.3-.79-.6-1.17-.91.39.31.78.61,1.17.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M406.51,59.86c.43.15.87.31,1.3.46-.43-.16-.86-.31-1.3-.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M408.96,60.76c.43.16.87.33,1.3.5-.43-.17-.86-.33-1.3-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M281.68,215.21c-.27-.43-.54-.86-.8-1.3.26.44.53.87.8,1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M401.51,58.25c.44.13.87.26,1.31.39-.43-.13-.87-.26-1.31-.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M427.5,69.94c.41.26.82.51,1.23.78-.41-.26-.82-.52-1.23-.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M372.34,53.97c.45,0,.9,0,1.35.02-.45,0-.9-.01-1.35-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M396.41,56.89c.44.11.88.21,1.31.32-.44-.11-.88-.22-1.31-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M393.83,56.3c.44.09.88.19,1.32.29-.44-.1-.88-.2-1.32-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M311.56,246.68c-.4-.28-.8-.56-1.2-.84.4.28.8.56,1.2.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M398.98,57.54c.44.12.88.24,1.31.36-.44-.12-.87-.24-1.31-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M377.83,54.14c.45.03.9.05,1.34.09-.45-.03-.9-.06-1.34-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M375.1,54.02c.45.01.9.03,1.35.05-.45-.02-.9-.04-1.35-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M423.06,67.32c.42.23.84.47,1.26.71-.42-.24-.84-.48-1.26-.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M362.48,112.15c-1.64-.89-3.14-2.01-4.45-3.33,1.31,1.31,2.81,2.43,4.45,3.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M420.79,66.08c.42.22.85.45,1.27.68-.42-.23-.84-.45-1.27-.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M318.06,250.85c-.42-.25-.83-.49-1.24-.74.41.25.83.5,1.24.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M315.86,249.52c-.41-.26-.82-.52-1.23-.78.41.26.82.52,1.23.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M279.07,210.74c-.25-.44-.49-.89-.73-1.33.24.45.49.89.73,1.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M425.3,68.6c.42.25.83.49,1.24.74-.41-.25-.83-.5-1.24-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M411.39,61.71c.43.18.86.35,1.29.53-.43-.18-.86-.36-1.29-.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M280.35,212.99c-.26-.44-.52-.88-.77-1.32.25.44.51.88.77,1.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M413.79,62.72c.43.19.86.38,1.28.57-.43-.19-.86-.38-1.28-.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M313.69,248.12c-.41-.27-.81-.54-1.21-.81.4.27.81.54,1.21.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M416.15,63.78c.43.2.85.4,1.28.6-.42-.2-.85-.4-1.28-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M352.37,95.17h0c0-5.33,2.16-10.16,5.66-13.65-3.49,3.49-5.66,8.32-5.66,13.65s2.16,10.16,5.66,13.65c-3.49-3.49-5.66-8.32-5.66-13.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M418.49,64.91c.42.21.85.42,1.27.64-.42-.22-.85-.43-1.27-.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M476.9,148.97c.04.42.09.85.13,1.27-.04-.43-.09-.85-.13-1.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M268.7,183.84c-.11-.46-.22-.91-.32-1.37.1.46.21.91.32,1.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M476.21,143.55c.07.44.14.88.2,1.32-.06-.44-.13-.88-.2-1.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M475.76,140.89c.08.44.17.89.24,1.33-.07-.45-.16-.89-.24-1.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M267.61,178.58c-.08-.45-.17-.9-.24-1.35.08.45.16.9.24,1.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M388.59,55.32c.44.07.88.14,1.32.22-.44-.08-.88-.15-1.32-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M383.25,54.6c.44.05.89.1,1.33.15-.44-.05-.89-.11-1.33-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M385.93,54.92c.44.06.89.12,1.33.19-.44-.07-.88-.13-1.33-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M476.58,146.24c.06.44.12.87.17,1.31-.05-.44-.11-.87-.17-1.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M358.03,133.39c1.31-1.31,2.81-2.43,4.45-3.32-1.64.89-3.14,2.01-4.45,3.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M474.02,133.01c.12.46.24.92.36,1.38-.11-.46-.24-.92-.36-1.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M269.34,186.42c-.12-.45-.24-.9-.35-1.36.11.45.23.91.35,1.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M274.48,201.39c-.2-.46-.4-.91-.59-1.37.19.46.39.92.59,1.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M352.37,224.28v-.54h0v.54c0,4.45,1.52,8.54,4.05,11.8h0c-2.53-3.27-4.05-7.35-4.05-11.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M473.32,130.45c.13.46.27.92.4,1.38-.13-.46-.26-.92-.4-1.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M475.24,138.23c.09.45.19.9.28,1.36-.09-.45-.19-.9-.28-1.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M267.16,175.89c-.07-.44-.14-.87-.2-1.31.06.44.13.87.2,1.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M415.72,255.85c-2.08.96-4.2,1.85-6.35,2.67,2.15-.83,4.27-1.71,6.35-2.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M266.78,173.19c-.05-.43-.11-.85-.16-1.28.05.43.11.85.16,1.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M444.61,236.19c-1.2,1.15-2.44,2.27-3.69,3.36,1.26-1.09,2.49-2.21,3.69-3.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M434.23,244.9c-2.4,1.77-4.88,3.45-7.42,5.01,2.55-1.57,5.02-3.24,7.42-5.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M288.67,94.34c1.03-1.31,2.1-2.59,3.19-3.85-1.09,1.26-2.16,2.54-3.19,3.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M421.69,252.85c-1.22.66-2.45,1.3-3.69,1.91,1.25-.61,2.48-1.25,3.69-1.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M391.22,55.78c.44.08.88.17,1.32.26-.44-.09-.88-.17-1.32-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M266.46,170.44c-.04-.41-.09-.82-.13-1.23.04.41.08.82.13,1.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M477.32,154.59c.02.37.04.73.06,1.1-.01-.37-.04-.74-.06-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M477.14,151.74c.03.41.07.81.09,1.22-.03-.41-.06-.81-.09-1.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M282.24,216.1c.19.3.38.6.58.89h0c-.19-.3-.39-.59-.58-.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M477.42,157.54c0,.3.02.6.02.91,0-.3-.02-.6-.02-.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M268.12,181.23c-.09-.46-.19-.91-.28-1.37.09.46.19.91.28,1.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M474.67,135.61c.11.46.22.91.32,1.37-.1-.46-.21-.91-.32-1.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M463.02,106.47c.26.44.51.87.76,1.31-.25-.44-.51-.88-.76-1.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M346.95,262.57c-.44-.11-.88-.21-1.32-.33.44.11.88.22,1.32.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M461.68,104.24c.27.43.54.87.8,1.3-.26-.44-.53-.87-.8-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M344.39,261.91c-.44-.12-.88-.24-1.31-.36.44.12.87.24,1.31.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M464.3,108.72c.24.44.49.88.73,1.33-.24-.45-.48-.89-.73-1.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M465.53,111c.23.45.47.89.7,1.35-.23-.45-.46-.9-.7-1.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M349.54,263.15c-.44-.09-.88-.19-1.32-.29.44.1.88.2,1.32.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M272.53,196.52c-.17-.46-.35-.92-.51-1.38.17.46.34.92.51,1.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M458.86,99.92c.29.42.58.84.86,1.27-.28-.43-.57-.85-.86-1.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M273.48,198.97c-.18-.46-.37-.91-.55-1.38.18.46.36.92.55,1.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M457.37,97.82c.3.41.6.83.89,1.24-.29-.42-.59-.83-.89-1.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M270.04,188.98c-.13-.45-.26-.9-.39-1.36.12.46.26.91.39,1.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M460.29,102.06c.28.43.56.86.83,1.29-.27-.43-.55-.86-.83-1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M341.85,261.2c-.44-.13-.87-.26-1.31-.39.44.13.87.27,1.31.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M339.34,260.43c-.44-.14-.87-.28-1.3-.43.43.15.87.29,1.3.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M354.79,264.14c-.44-.07-.89-.15-1.33-.22.44.08.89.15,1.33.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M380.55,54.34c.45.04.89.08,1.34.12-.44-.04-.89-.08-1.34-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M470.84,122.93c.17.46.35.92.51,1.38-.17-.46-.34-.92-.51-1.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M471.72,125.4c.16.46.32.93.47,1.39-.15-.47-.32-.93-.47-1.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M466.7,113.31c.22.45.45.91.66,1.37-.22-.46-.44-.91-.66-1.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M270.81,191.52c-.14-.46-.29-.91-.43-1.37.14.46.28.91.43,1.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M472.55,127.91c.15.46.3.92.44,1.39-.14-.47-.29-.93-.44-1.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M352.37,147.05c0-5.33,2.16-10.16,5.66-13.65-3.49,3.49-5.66,8.32-5.66,13.65v19.62h0v-19.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M469.89,120.48c.18.46.37.91.55,1.38-.18-.46-.36-.92-.55-1.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M352.15,263.68c-.44-.08-.88-.17-1.33-.26.44.09.88.17,1.33.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M467.82,115.67c.21.46.42.92.63,1.38-.2-.46-.42-.92-.63-1.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M271.64,194.04c-.16-.46-.32-.92-.47-1.38.15.46.31.92.47,1.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M468.88,118.06c.2.46.4.91.59,1.38-.19-.46-.39-.92-.59-1.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M356.42,236.09c.32.41.66.81,1.01,1.2-.35-.39-.69-.78-1.01-1.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M287.53,223.7c-.31-.4-.62-.81-.92-1.22.3.41.61.81.92,1.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M292.42,229.66c-.34-.38-.67-.76-1-1.14.33.38.67.76,1,1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M289.12,225.73c-.32-.4-.64-.8-.95-1.2.31.4.63.8.95,1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M290.75,227.72c-.33-.39-.66-.78-.98-1.17.32.39.65.78.98,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M295.91,233.43c-.35-.36-.7-.72-1.05-1.09.35.37.7.73,1.05,1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M294.15,231.57c-.34-.37-.69-.74-1.03-1.12.34.38.68.75,1.03,1.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M282.82,217c.08.13.17.26.25.38-.08-.13-.17-.26-.25-.39h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M285.99,221.63c-.3-.41-.6-.82-.89-1.24.29.41.59.82.89,1.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M373.17,265.48h0s0,0,0,0c5.3-.07,10.51-.54,15.61-1.38h0c-5.09.83-10.3,1.3-15.61,1.38Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 352.37,
    y: 166.66,
    width: 0,
    height: 57.08
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M356.42,264.39c.34.05.68.09,1.02.14-.34-.05-.68-.1-1.02-.14h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M371.03,265.49c-.46,0-.91,0-1.37-.02.46,0,.91.01,1.37.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M297.73,235.24c-.36-.35-.72-.71-1.07-1.06.35.36.71.71,1.07,1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M284.5,219.52c-.29-.42-.57-.83-.86-1.26.28.42.57.84.86,1.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M299.58,237.02c-.37-.34-.74-.69-1.1-1.04.36.35.73.69,1.1,1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M360.12,264.86c-.45-.05-.9-.1-1.34-.16.45.05.89.11,1.34.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M266.04,164.75c-.02-.33-.04-.66-.05-.98.01.33.03.66.05.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M266.22,167.63c-.03-.38-.06-.75-.09-1.13.02.38.06.75.09,1.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M368.28,265.43c-.46-.01-.91-.03-1.36-.05.45.02.91.04,1.36.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M365.54,265.31c-.45-.03-.91-.06-1.36-.09.45.03.9.06,1.36.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M362.82,265.12c-.45-.04-.9-.08-1.34-.12.45.04.9.08,1.34.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M303.41,240.43c-.38-.32-.76-.64-1.14-.97.38.33.76.65,1.14.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M301.48,238.75c-.37-.33-.75-.67-1.12-1.01.37.34.74.67,1.12,1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M361.49,240.66c-.98-.61-1.89-1.3-2.74-2.07.85.77,1.76,1.46,2.74,2.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M305.39,242.06c-.39-.31-.77-.62-1.15-.94.38.32.77.63,1.15.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M265.94,161.74c0-.24-.01-.48-.02-.72,0,.24.01.48.02.72Z"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRoomDetails);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/room_details.fafb96548c44100a440ebecc028a1eaf.svg";